<template>
  <el-drawer custom-class="shift_edit_modal bottom_drop_up" direction="btt" v-model="modalVisible" title=" Edit "
    @open="openModal" @close="closeModal" :append-to-body="true">
    <el-form :model="formsData.shiftForm" :rules="formsData.shiftForm.rules"
      :ref="(el) => (formsData.shiftForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('shiftForm')">
      <el-tabs v-model="activeName" stretch :before-leave="handleClick">
        <el-tab-pane label="Edit Shift Visibility" name="Visibility" :disabled="enableTabClick">
          <div class="flex items-center text-sm">
            <el-checkbox-group v-model="formsData.shiftForm.visibility_status.value" @change="updateVisibilityOptions">
              <template v-for="visibilityOption in visibiltyOptions" :key="visibilityOption.value">
                <div v-if="visibilityOption.isDynamicPool" class="pools-group">
                  <div class="pools-group-header" v-if="visibilityOption.isFirstPool">
                    <div class="label-title">{{ visibilityOption.groupTitle }}</div>
                    <div class="label-sub">{{ visibilityOption.groupSubText }}</div>
                  </div>
                  <div class="switch-wrapper">
                    <el-form-item>
                      <el-checkbox class="custom-switch" :label="visibilityOption.value" size="large"
                        :disabled="shouldDisableCheckbox(visibilityOption)"
                        v-model="formsData.shiftForm.visibility_status.value">
                        <div class="d-flex align-items-center w-full">
                          <div v-html="visibilityOption.icon"></div>
                          <div class="shift_locum ml-2">
                            <span class="label-title">{{ visibilityOption.label }}</span>
                            <span class="label-sub" v-if="checkLocumAvailability(visibilityOption)">
                              {{ visibilityOption.noLocum }}
                            </span>
                            <span class="label-sub"
                              v-if="checkSubscriptionEnabledDIsabled(visibilityOption) && visibilityOption?.poolData?.structure?.name === 'Group'">
                              ({{ subscriptionAvailiabilityText }})
                            </span>
                            <span class="label-sub" v-if="!shouldDisableCheckbox(visibilityOption)">
                              {{ visibilityOption.description }}
                            </span>
                          </div>
                          <div class="ml-auto d-flex align-items-center">
                            <el-tag class="inverted outlined" size="small">
                              {{ visibilityOption.locumsCount }}
                            </el-tag>
                          </div>
                        </div>
                      </el-checkbox>
                    </el-form-item>
                    <div v-if="formsData.shiftForm.visibility_status.value.includes(visibilityOption.value)"
                      class="shift-options">

                      <el-form-item v-if="visibilityOption?.poolData?.structure?.name === 'Group'">
                        <el-radio-group class="lvl1-radio-group" v-model="poolRadioSelections[visibilityOption.value]"
                          @change="val => handleInternalRadioChange(val, visibilityOption.value)">
                          <el-radio :label="'notify_all'">Notify all pool professionals</el-radio>
                          <el-radio :label="'choose_specific'"
                            @click="() => handleChooseInternalSpecificClick(visibilityOption.value)">
                            Let me choose specific professionals
                          </el-radio>
                        </el-radio-group>
                        <div class="choose-invalid-select" v-if="getPoolError(visibilityOption)">
                          Please select at least one professional.
                        </div>
                        <div class="professional-count"
                          v-if="formsData.shiftForm.more_option_internal_pools[visibilityOption.value].value.locums.length">
                          {{ formsData.shiftForm.more_option_internal_pools[visibilityOption.value].value.locums.length }}
                         {{ pluralizeWord('professional', formsData.shiftForm.more_option_internal_pools[visibilityOption.value].value.locums.length) }} selected</div>

                      </el-form-item>

                      <el-form-item class="tags-notification" v-if="visibilityOption.tags.length > 0"
                        label="Only notify the following groups">
                        <el-checkbox-group
                          v-model="formsData.shiftForm.more_option_internal_pools[visibilityOption.value].value.tags"
                          @change="handleTagSelection(visibilityOption.value)" class="tag-checkbox-group">
                          <div v-for="tag in visibilityOption.tags" :key="tag.id" class="tag-checkbox-item">
                            <el-checkbox :label="tag.id" size="small">
                              <!-- Render tag title and style manually -->
                              <el-tag size="small" :style="{
                                backgroundColor: getTagType(tag.title),
                                color: '#fff',
                                border: 'none'
                              }">
                                {{ tag.title }}
                              </el-tag>
                            </el-checkbox>
                          </div>
                        </el-checkbox-group>
                      </el-form-item>


                      <el-form-item>
                        <div class="option-wrapper">
                          <div class="option-wrapper-title d-flex align-items-center gap-2">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M9.99996 1.66669C5.40745 1.66669 1.66663 5.40752 1.66663 10C1.66663 14.5925 5.40745 18.3334 9.99996 18.3334C14.5925 18.3334 18.3333 14.5925 18.3333 10C18.3333 5.40752 14.5925 1.66669 9.99996 1.66669ZM9.99996 3.33335C13.6917 3.33335 16.6666 6.30825 16.6666 10C16.6666 13.6918 13.6917 16.6667 9.99996 16.6667C6.30819 16.6667 3.33329 13.6918 3.33329 10C3.33329 6.30825 6.30819 3.33335 9.99996 3.33335ZM9.16663 5.00002V10.3451L12.7441 13.9225L13.9225 12.7442L10.8333 9.65497V5.00002H9.16663Z"
                                fill="black" />
                            </svg>
                            <span class="label-title">When to notify</span>
                          </div>
                          <common-radio
                            v-model="formsData.shiftForm.more_option_internal_pools[visibilityOption.value].value.value"
                            :value="formsData.shiftForm.more_option_internal_pools[visibilityOption.value].value.value" />
                        </div>
                      </el-form-item>



                    </div>
                  </div>
                </div>

                <!-- For static options -->
                <div v-else class="pools-group">

                  <div class="pools-group-header" v-if="visibilityOption.value == 1 || visibilityOption.value == 3">
                    <div class="label-title">{{ visibilityOption.groupTitle }}</div>
                    <div class="label-sub">{{ visibilityOption.groupSubText }}</div>
                  </div>
                  <div class="switch-wrapper">

                    <el-form-item>
                      <el-checkbox class="custom-switch" :label="visibilityOption.value" size="large"
                        :disabled="shouldDisableCheckbox(visibilityOption)">
                        <div class="d-flex align-items-center w-full">
                          <div v-html="visibilityOption.icon"></div>
                          <div class="shift_locum ml-2">
                            <span class="label-title">{{ visibilityOption.label }}</span>
                            <span class="label-sub" v-if="checkSubscriptionEnabledDIsabled(visibilityOption)">
                              ({{ visibilityOption.value === 2 ?
                                pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText :
                                subscriptionAvailiabilityText }})
                            </span>
                            <span class="label-sub" v-else-if="checkLocumAvailability(visibilityOption)">
                              {{ visibilityOption.noLocum }}
                            </span>
                            <span class="label-sub" v-if="!shouldDisableCheckbox(visibilityOption)">
                              {{ visibilityOption.description }}
                            </span>
                          </div>
                          <div class="ml-auto d-flex align-items-center"
                            v-if="visibilityOption.value == 2 || visibilityOption.value == 4">
                            <el-tag class="inverted outlined" size="small">
                              <span v-if="visibilityOption.value == 2">{{ preferedLocums.length }}</span>
                              <span v-if="visibilityOption.value == 4">{{ agencies.length }}</span>
                            </el-tag>
                          </div>
                        </div>
                      </el-checkbox>
                    </el-form-item>



                    <!-- Preferred Locum -->
                    <div v-if="visibilityOption.value == 2 && visibilityOption.visibility">
                      <div v-if="formsData.shiftForm.visibility_status.value.includes(2)" class="shift-options">
                        <el-form-item>
                          <el-radio-group class="lvl1-radio-group" v-model="preferedRadioSelection"
                            @change="handlePreferedRadioChange">
                            <el-radio :label="'notify_all'">Notify all preferred
                              professionals</el-radio>
                            <el-radio :label="'choose_specific'" @click="handleChoosePreferedSpecificClick">Let me
                              choose
                              specific preferred professionals</el-radio>
                          </el-radio-group>
                          <div class="choose-invalid-select" v-if="checkPreferedRadioIsChooseSpecific">Please select at
                            least one
                            preferred professional.</div>
                          <div class="professional-count"
                            v-if="formsData.shiftForm.more_option_prefered_locum.value.locums.length">
                            {{ formsData.shiftForm.more_option_prefered_locum.value.locums.length }} 
                            {{ pluralizeWord('professional', formsData.shiftForm.more_option_prefered_locum.value.locums.length) }} selected</div>
                        </el-form-item>
                        <el-form-item>
                          <div class="option-wrapper">
                            <div class="option-wrapper-title d-flex align-items-center gap-2">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M9.99996 1.66669C5.40745 1.66669 1.66663 5.40752 1.66663 10C1.66663 14.5925 5.40745 18.3334 9.99996 18.3334C14.5925 18.3334 18.3333 14.5925 18.3333 10C18.3333 5.40752 14.5925 1.66669 9.99996 1.66669ZM9.99996 3.33335C13.6917 3.33335 16.6666 6.30825 16.6666 10C16.6666 13.6918 13.6917 16.6667 9.99996 16.6667C6.30819 16.6667 3.33329 13.6918 3.33329 10C3.33329 6.30825 6.30819 3.33335 9.99996 3.33335ZM9.16663 5.00002V10.3451L12.7441 13.9225L13.9225 12.7442L10.8333 9.65497V5.00002H9.16663Z"
                                  fill="black" />
                              </svg>
                              <span class="label-title">When to notify</span>
                            </div>
                            <common-radio v-model="formsData.shiftForm.more_option_prefered_locum.value.value"
                              :value="formsData.shiftForm.more_option_prefered_locum.value.value" />
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <!-- Open Marketplace -->
                    <div v-if="visibilityOption.value == 3 && visibilityOption.visibility">
                      <div v-if="formsData.shiftForm.visibility_status.value.includes(3)" class="shift-options">
                        <el-form-item>
                           <div class="option-wrapper">
                            <div class="option-wrapper-title d-flex align-items-center gap-2">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M9.99996 1.66669C5.40745 1.66669 1.66663 5.40752 1.66663 10C1.66663 14.5925 5.40745 18.3334 9.99996 18.3334C14.5925 18.3334 18.3333 14.5925 18.3333 10C18.3333 5.40752 14.5925 1.66669 9.99996 1.66669ZM9.99996 3.33335C13.6917 3.33335 16.6666 6.30825 16.6666 10C16.6666 13.6918 13.6917 16.6667 9.99996 16.6667C6.30819 16.6667 3.33329 13.6918 3.33329 10C3.33329 6.30825 6.30819 3.33335 9.99996 3.33335ZM9.16663 5.00002V10.3451L12.7441 13.9225L13.9225 12.7442L10.8333 9.65497V5.00002H9.16663Z"
                                  fill="black" />
                              </svg>
                              <span class="label-title">When to notify</span>
                            </div>
                          <common-radio v-model="formsData.shiftForm.more_option_open_marketplace.value.value"
                            :value="formsData.shiftForm.more_option_open_marketplace.value.value" />
                            </div>
                        </el-form-item>
                        <el-form-item class="c-outer">
                          <div v-if="onboardingFeature === 'true'">
                            <el-checkbox-group
                              v-model="formsData.shiftForm.more_option_open_marketplace.value.onboarding">
                              <el-checkbox class="c-label" @click.prevent="handleCheckboxClickForOnboarding()">
                                <span class="label-title ml-2">I am willing to onboard locum as an employee</span>
                              </el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <!-- Agency -->
                    <div v-if="visibilityOption.value == 4 && visibilityOption.visibility">
                      <div v-if="formsData.shiftForm.visibility_status.value.includes(4)" class="shift-options">
                        <el-form-item>
                          <el-radio-group class="lvl1-radio-group" v-model="agencyRadioSelection"
                            @change="handleAgencyRadioChange">
                            <el-radio :label="'notify_all'">Notify all preferred agencies</el-radio>
                            <el-radio :label="'choose_specific'" @click="handleChooseAgencySpecificClick">Let me choose specific preferred agencies</el-radio>
                          </el-radio-group>
                          <div class="choose-invalid-select" v-if="checkAgencyRadioIsChooseSpecific">Please select at least one preferred agency</div>
                          <div class="professional-count"
                            v-if="formsData.shiftForm.more_option_agency.value.agencies.length">
                            {{ formsData.shiftForm.more_option_agency.value.agencies.length }}
                            {{ pluralizeWord('agency', formsData.shiftForm.more_option_agency.value.agencies.length) }} selected</div>
                        </el-form-item>
                        <el-form-item>
                          <div class="option-wrapper">
                            <div class="option-wrapper-title d-flex align-items-center gap-2">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M9.99996 1.66669C5.40745 1.66669 1.66663 5.40752 1.66663 10C1.66663 14.5925 5.40745 18.3334 9.99996 18.3334C14.5925 18.3334 18.3333 14.5925 18.3333 10C18.3333 5.40752 14.5925 1.66669 9.99996 1.66669ZM9.99996 3.33335C13.6917 3.33335 16.6666 6.30825 16.6666 10C16.6666 13.6918 13.6917 16.6667 9.99996 16.6667C6.30819 16.6667 3.33329 13.6918 3.33329 10C3.33329 6.30825 6.30819 3.33335 9.99996 3.33335ZM9.16663 5.00002V10.3451L12.7441 13.9225L13.9225 12.7442L10.8333 9.65497V5.00002H9.16663Z"
                                  fill="black" />
                              </svg>
                              <span class="label-title">When to notify</span>
                            </div>
                            <common-radio v-model="formsData.shiftForm.more_option_agency.value.value"
                              :value="formsData.shiftForm.more_option_agency.value.value" />
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                  </div>

                </div>
              </template>
            </el-checkbox-group>
          </div>

          <div class="el-dialog__footer d-flex">
            <el-button class="submit_page secondary flex-1" type="grey" @click="closeModal">
              <span>Cancel</span>
            </el-button>
            <el-button class="submit_page flex-1" type="blue"  :disabled="!isButtonEnabled"
              @click="next('shiftForm', 'Visibility', 'Access', 'Primary')">
              <span>Next</span>
            </el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Shift Access" name="Access" :disabled="enableTabClick">
          <el-form-item>
            <div class="my-4 flex items-center text-sm shift-access">
              <el-radio-group v-model="formsData.shiftForm.shift_application_type.value"
                @change="updateVisibilityAccess">
                <template v-for="visibilityAccessOption in visibiltyAccessOptions" :key="visibilityAccessOption.value"
                  style="margin-bottom: 1rem">
                  <el-form-item v-if="!visibilityAccessOption.doesSubscriptionEffect">
                    <el-radio :label="visibilityAccessOption.value" size="large"
                      :disabled="visibilityAccessOption.visibility">
                      <p class="shift-access-label mb-0">{{ visibilityAccessOption.label }}</p>
                    </el-radio>
                    <p class="description">{{ visibilityAccessOption.description }}</p>
                    <el-item v-if="formsData.shiftForm.shift_application_type.value === 2">
                      <p class="description" v-if="visibilityAccessOption.value === 2">
                        Must apply if outside of
                        <el-select v-model="formsData.shiftForm.application_radius.value" class="c-group"
                          placeholder="Select" size="large">
                          <el-option v-for="item in radiusAccessValue" :key="item.value" :label="item.label"
                            :value="item.value" />
                        </el-select>
                        <span v-if="formsData.shiftForm.application_radius.value == undefined && formsData.shiftForm.shift_application_type.value === 2 && visibilityAccessOption.value === 2" style="color: red; font-size: 14px; line-height: 1; margin-bottom: 0; margin-top: 8px;">Radius is required</span>
                      </p>
                    </el-item>

                  </el-form-item>
                </template>
              </el-radio-group>
            </div>
            <div class="el-dialog__footer d-flex">
              <el-button class="submit_page secondary flex-1" type="grey" @click="closeModal">
                <span>Cancel</span>
              </el-button>
              <el-button class="submit_page flex-1" type="blue"  :disabled="!isButtonEnabled" @click="next('shiftForm', 'Access', 'Primary')">
                <span>Next</span>
              </el-button>
            </div>
          </el-form-item>
        </el-tab-pane>

        <el-tab-pane label="Edit shift" name="Primary" :disabled="enableTabClick">
          <el-form-item class="schedule_form_time" label="Shift hours" prop="shiftTime" :required="true">
            <ion-item>
              <ion-datetime v-model="formsData.shiftForm.shiftTime.value.timeStart" display-format="h:mm A"
                minute-values="0,15,30,45" placeholder="Start Time"
                @ionChange="checkFormValidation('shiftForm', true, 'shiftTime')"></ion-datetime>
            </ion-item>
            <ion-item>
              <ion-datetime v-model="formsData.shiftForm.shiftTime.value.timeEnd" display-format="h:mm A"
                minute-values="0,15,30,45" placeholder="End Time"
                @ionChange="checkFormValidation('shiftForm', true, 'shiftTime')"></ion-datetime>
            </ion-item>
          </el-form-item>
          <div class="form_text page_padding_top">
            <div class="title">Hourly Payment range</div>
            <div class="text_note" v-if="isAustralia">(excluding super)</div>
          </div>

          <el-form-item prop="rate" class="rate_form_inputs_wrapper">
            <el-form-item label="Min. Pay Rate" :required="true" class="el-input">
              <input type="tel" class="input_currency el-input__inner" :value="formsData.shiftForm.rate.value.minRate"
                :placeholder="'0.00'" v-imask="formsData.shiftForm.rate.mask" @accept="
                  onFormMaskAccept($event, 'shiftForm', {
                    name: 'rate',
                    value: 'minRate',
                  })
                  " @blur="checkFormValidation('shiftForm', true, 'rate')" />
              <span class="el-input__suffix">AUD</span>
            </el-form-item>
            <el-form-item label="Max. Pay Rate" :required="true" class="el-input">
              <input type="tel" class="input_currency el-input__inner" :value="formsData.shiftForm.rate.value.maxRate"
                :placeholder="'0.00'" v-imask="formsData.shiftForm.rate.mask" @accept="
                  onFormMaskAccept($event, 'shiftForm', {
                    name: 'rate',
                    value: 'maxRate',
                  })
                  " @blur="checkFormValidation('shiftForm', true, 'rate')" />
              <span class="el-input__suffix">AUD</span>
            </el-form-item>

          </el-form-item>
          <div class="travel-dropdown">
            <div class="travel-label">Travel payment:</div>
            <el-select class="covid-cert-select" style="width: 100%"
              v-model="formsData.shiftForm.paying_for_travel.value" placeholder="Select" @change="handleSelectChange">
              <el-option label="No travel payment" :value="0" />
              <!-- <el-option label="Partial travel payment" :value="1">
                <div>
                  <span>Partial travel payment</span>
                  <div style="color: grey; font-size: 13px; margin-top: -15px">
                    Paying for Travel(>50KM roundtrip)
                  </div>
                </div>
              </el-option> -->
              <el-option label="Full travel payment" :value="2" />
              <el-option label="Capped travel amount" :value="3" />
            </el-select>
          </div>
          <el-form-item prop="max_travel_amount" v-if="formsData.shiftForm.paying_for_travel.value == 3"
            class="price-input-outer travel-cc">

            <div class="travel-label">Max travel amount:</div>
            <div class="amount-flex">

              <el-input type="number" v-if="formsData.shiftForm.paying_for_travel.value == 3"
                v-model="formsData.shiftForm.max_travel_amount.value" :placeholder="'Enter max travel amount'"
                :precision="2" :step="0.1" :min="0" @change="checkFormValidation('shiftForm', false, 'maxTravelAmount')"
                @blur="checkFormValidation('shiftForm', true, 'maxTravelAmount')"
                @keyup="formsData.shiftForm.max_travel_amount.value = $event.target.value">
              </el-input>
              <div class="sign-price">AUD</div>
            </div>


          </el-form-item>
          <el-form-item label="Shift Date" prop="shiftDate" :required="true">
            <div class="el-input el-input--prefix">
              <input type="tel" class="el-input__inner" :ref="(el) => (formsData.shiftForm.shiftDate.ref = el)"
                :value="formsData.shiftForm.shiftDate.value" :placeholder="$filters.systemDateFormat()"
                v-imask="formsData.shiftForm.shiftDate.mask"
                @accept="onFormMaskAccept($event, 'shiftForm', 'shiftDate')" @blur="() => {
                  checkFormValidation('shiftForm', true, 'shiftDate');
                }
                " />
              <span class="el-input__prefix"><i class="el-input__icon el-icon-date"></i></span>
            </div>
          </el-form-item>
          <!-- <el-form-item label="Do you want this job to be booked by single Locum?" class="font-weight-bold">
                    <el-switch
                        v-model="formsData.shiftForm.isBlockShift.value"
                        size="default"
                        class="mb-2"
                        active-text="Yes"
                        inactive-text="No"
                    />
          </el-form-item> -->
          <v-date-picker class="calendar_comp v-date-picker" :ref="(el) => (calendarRef = el)" v-model="dateSelected"
            :rows="1" :attributes="calendarAttrs" :min-date="new Date()" :disabled-dates="disabledDates" trim-weeks
            :update-on-input="true" @transition-end="calendarUpdate" />
          <div class="el-dialog__footer d-flex">
            <el-button class="submit_page secondary flex-1" type="grey" @click="closeModal">
              <span>Cancel</span>
            </el-button>
            <el-button class="submit_page flex-1" type="blue"  :disabled="!isButtonEnabled" @click="next('shiftForm', 'Primary', 'Secondary')">
              <span>Next</span>
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Additional Information" name="Secondary" :disabled="enableTabClick" :lazy="true">
          <el-form-item>
            <el-checkbox v-model="formsData.shiftForm.solo.value">Solo {{ $filters.systemLocumName(false, true) }}
              <br />
              <span class="label-sub">Will the {{ $filters.systemLocumName(false, false) }} be the only pharmacist
                during this
                shift?</span></el-checkbox>
          </el-form-item>
          <el-form-item v-if="formsData.shiftForm.isBlockShift.value === true">
            <el-checkbox v-model="formsData.shiftForm.enable_travel_allowance_for_first_and_last_day.value"
              :true-label="1">Will
              pay for travel first and last day
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="formsData.shiftForm.pay_for_flights.value" :true-label="1">Will pay for flights
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="formsData.shiftForm.pay_for_accommodation.value" :true-label="1">Will pay for
              accomodation
            </el-checkbox>
          </el-form-item>
          <!-- <el-form-item>
            <el-checkbox v-model="formsData.shiftForm.admin_aids.value">Dosage Administration Aids
            </el-checkbox>
          </el-form-item> -->

          <div class="flag__input-wrapper">
            <el-form-item>
              <el-checkbox @change="onChangeTech" v-model="formsData.shiftForm.number_of_technicians.value">Number of
                Technicians
              </el-checkbox>
            </el-form-item>
            <!-- <el-form-item prop="num_of_tech">
              <el-input type="number" class="number_input" placeholder="0" :min="0" :max="50"
                :disabled="!formsData.shiftForm.number_of_technicians.value"
                v-model="formsData.shiftForm.num_of_tech.value"></el-input>
            </el-form-item> -->
            <el-form-item prop="num_of_tech">
              <el-input-number class="el-input-number1" size="small" placeholder="0" :min="0" :max="50"
                :disabled="!formsData.shiftForm.number_of_technicians.value"
                v-model="formsData.shiftForm.num_of_tech.value"></el-input-number>

            </el-form-item>
          </div>

          <el-form-item>
            <el-checkbox v-model="formsData.shiftForm.open_up.value">Open Pharmacy
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="formsData.shiftForm.close.value">Close Pharmacy
            </el-checkbox>
          </el-form-item>

          <!-- <div class="form_text">
            <div class="title">Select Platform Role</div>
          </div>

          <el-form-item>
            <el-select class="custom-select" popper-class="normal-select"
              v-model="formsData.shiftForm.platform_role_id.value" placeholder="Platform Role"
              label="Platform Role Required">
              <el-option v-for="item in platformRoleOption" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->

          <div class="form_text">
            <div class="title">{{ message.Immuniser }} Required??</div>
          </div>

          <el-form-item>
            <el-select class="custom-select" popper-class="normal-select"
              v-model="formsData.shiftForm.covid_cert_required.value" placeholder="Vaccination requirements">
              <el-option v-for="item in covidRequiredOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-checkbox @change="onChangeLang" v-model="formsData.shiftForm.language_conditions.value">Language
              Preferences?
            </el-checkbox>
          </el-form-item>
          <el-form-item class="no-scroll">
            <div class="select_wrapper" v-for="(select, i) in formsData.shiftForm.languages.selectValue" :key="i">
              <VueMultiselect v-model="formsData.shiftForm.languages.selectValue[i]"
                :options="formsData.shiftForm.languages.options[i]" :searchable="true" :allow-empty="false"
                label="title" :placeholder="'Select language'" track-by="title" :show-labels="false" :id="i"
                :custom-label="customLabel" @select="selectOptions"
                :disabled="!formsData.shiftForm.language_conditions.value">
                <template #singleLabel="props">
                  <span :class="'flag-icon flag-icon-' + props.option.flag"></span>
                  <span>{{ props.option.title }}</span>
                </template>
                <template #option="props" :class="props.option.show">
                  <span :class="'flag-icon flag-icon-' + props.option.flag"></span>
                  <span>{{ props.option.title }}</span>
                </template>
              </VueMultiselect>
              <el-button type="transparent" circle @click="removeOption(i)"
                :disabled="!formsData.shiftForm.languages.remove[i]">
                <i class="el-icon-close"></i>
              </el-button>
            </div>
          </el-form-item>

          <el-form-item>
            <el-checkbox @change="onChangeParking" v-model="formsData.shiftForm.parking_check.value">Parking
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-input class="custom-input" placeholder="eg. Park at the back of the building"
              :disabled="!formsData.shiftForm.parking_check.value" v-model="formsData.shiftForm.parking.value" :class="{
                'red-border': formsData.shiftForm.parking_check.value && formsData.shiftForm.parking.value === '',
                'default-border': !formsData.shiftForm.parking_check.value
              }"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox @change="onChangeNotes" v-model="formsData.shiftForm.additional_notes.value">Additional Notes
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-input class="custom-input" :disabled="!formsData.shiftForm.additional_notes.value" type="textarea"
              :rows="7" placeholder="Enter your notes" v-model="formsData.shiftForm.notes.value">
            </el-input>
          </el-form-item>
          <div class="el-dialog__footer d-flex">
            <el-button class="submit_page secondary flex-1" type="grey" @click="closeModal">
              <span>Cancel</span>
            </el-button>
            <el-button class="submit_page flex-1" type="blue" @click="submit('shiftForm', 'Secondary')"
              :disabled="formsData.shiftForm.parking_check.value && formsData.shiftForm.parking.value === ''">
              <span>Save</span>
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-drawer>

  <el-dialog v-model="showDialog" modal-class="modal-dialog-custom" title="Agency Rates/Notes" width="30%">
    <div class="modal-c">
      <p class="modal-name" slot="title">{{ selectedAgencyData.name }}</p>
      <p><strong>Email:</strong> {{ selectedAgencyData.email }}</p>
      <p><strong> Rate:</strong> $ {{ selectedAgencyData.rates }}</p>
      <div class="modal-note" v-if="selectedAgencyData.notes.length > 0"><strong>Notes: </strong>

        <ul>
          <!-- <li v-for="note in selectedAgencyData.notes" :key="note.id">{{ note.note }}</li> -->
          <li :key="selectedAgencyData.notes[0].id">{{ selectedAgencyData.notes[0].note }}</li>
        </ul>
      </div>
      <div class="modal-note" v-else><strong>Notes: </strong>
        <p>Note not found</p>
      </div>

    </div>

    <template #footer>
      <span class="dialog-footer footer-btn">
        <el-button @click="showDialog = false">Close</el-button>
      </span>
    </template>
  </el-dialog>


  <ProfessionalSelectionDrawer v-model="preferedDrawer" title="Preferred professionals" icon='<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="8" fill="#FFF6DE" />
            <path
            d="M15.9546 5.57036C15.7925 5.57783 15.6365 5.63444 15.5073 5.73268C15.378 5.83091 15.2818 5.96612 15.2312 6.12036L13.0671 12.7344L6.10933 12.7485C5.9409 12.7491 5.77696 12.8028 5.64084 12.902C5.50473 13.0012 5.4034 13.1408 5.35128 13.301C5.29916 13.4611 5.29892 13.6337 5.35058 13.794C5.40225 13.9543 5.50319 14.0942 5.63902 14.1938L11.2609 18.2954L9.1234 24.9188C9.07184 25.0792 9.07224 25.2518 9.12455 25.412C9.17686 25.5722 9.27841 25.7117 9.41471 25.8108C9.55101 25.9099 9.71512 25.9634 9.88362 25.9637C10.0521 25.964 10.2164 25.9111 10.3531 25.8125L15.9906 21.7329L21.6296 25.8125C21.7663 25.9111 21.9306 25.964 22.0991 25.9637C22.2676 25.9634 22.4317 25.9099 22.568 25.8108C22.7043 25.7117 22.8059 25.5722 22.8582 25.412C22.9105 25.2518 22.9109 25.0792 22.8593 24.9188L20.7218 18.2954L26.3437 14.1938C26.4795 14.0942 26.5805 13.9543 26.6321 13.794C26.6838 13.6337 26.6836 13.4611 26.6314 13.301C26.5793 13.1408 26.478 13.0012 26.3419 12.902C26.2058 12.8028 26.0418 12.7491 25.8734 12.7485L18.914 12.7344L16.7515 6.12036C16.697 5.9542 16.5896 5.81046 16.4457 5.71113C16.3018 5.6118 16.1293 5.56236 15.9546 5.57036ZM15.9906 8.94379L17.5734 13.7829C17.6257 13.9431 17.7273 14.0826 17.8637 14.1817C18.0001 14.2807 18.1642 14.3342 18.3328 14.3344L23.4234 14.3438L19.3109 17.3438C19.175 17.4432 19.0738 17.5829 19.0219 17.7431C18.97 17.9033 18.97 18.0758 19.0218 18.236L20.5859 23.0829L16.4593 20.0969C16.3229 19.9983 16.1589 19.9452 15.9906 19.9452C15.8223 19.9452 15.6582 19.9983 15.5218 20.0969L11.3984 23.0813L12.9609 18.236C13.0127 18.0758 13.0127 17.9033 12.9608 17.7431C12.9089 17.5829 12.8078 17.4432 12.6718 17.3438L8.55933 14.3438L13.65 14.3344C13.8182 14.3339 13.982 14.2802 14.1181 14.1812C14.2541 14.0822 14.3555 13.9428 14.4078 13.7829L15.9906 8.94379Z"
            fill="#FFB800" />
            </svg>' description="Your preferred pharmacy professionals (Internal or External)" :items="preferedLocums"
    :show-info-icon="false" type="preferred" :selected="formsData.shiftForm.more_option_prefered_locum.value.locums"
    @update:selected="updatePreferedLocums" />

  <ProfessionalSelectionDrawer v-model="agencyDrawer" title="Agencies" icon='<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="8" fill="#DBEAFE"/>
            <path d="M26.5 23.5H25V13C25 12.6022 24.842 12.2206 24.5607 11.9393C24.2794 11.658 23.8978 11.5 23.5 11.5H17.5V7C17.5002 6.72837 17.4266 6.46179 17.2871 6.22872C17.1476 5.99564 16.9474 5.80482 16.708 5.67661C16.4685 5.54841 16.1987 5.48764 15.9274 5.50078C15.6561 5.51393 15.3935 5.60049 15.1675 5.75125L7.6675 10.75C7.46176 10.8873 7.29315 11.0733 7.17669 11.2915C7.06023 11.5097 6.99953 11.7533 7 12.0006V23.5H5.5C5.30109 23.5 5.11032 23.579 4.96967 23.7197C4.82902 23.8603 4.75 24.0511 4.75 24.25C4.75 24.4489 4.82902 24.6397 4.96967 24.7803C5.11032 24.921 5.30109 25 5.5 25H26.5C26.6989 25 26.8897 24.921 27.0303 24.7803C27.171 24.6397 27.25 24.4489 27.25 24.25C27.25 24.0511 27.171 23.8603 27.0303 23.7197C26.8897 23.579 26.6989 23.5 26.5 23.5ZM23.5 13V23.5H17.5V13H23.5ZM8.5 12.0006L16 7V23.5H8.5V12.0006ZM14.5 14.5V16C14.5 16.1989 14.421 16.3897 14.2803 16.5303C14.1397 16.671 13.9489 16.75 13.75 16.75C13.5511 16.75 13.3603 16.671 13.2197 16.5303C13.079 16.3897 13 16.1989 13 16V14.5C13 14.3011 13.079 14.1103 13.2197 13.9697C13.3603 13.829 13.5511 13.75 13.75 13.75C13.9489 13.75 14.1397 13.829 14.2803 13.9697C14.421 14.1103 14.5 14.3011 14.5 14.5ZM11.5 14.5V16C11.5 16.1989 11.421 16.3897 11.2803 16.5303C11.1397 16.671 10.9489 16.75 10.75 16.75C10.5511 16.75 10.3603 16.671 10.2197 16.5303C10.079 16.3897 10 16.1989 10 16V14.5C10 14.3011 10.079 14.1103 10.2197 13.9697C10.3603 13.829 10.5511 13.75 10.75 13.75C10.9489 13.75 11.1397 13.829 11.2803 13.9697C11.421 14.1103 11.5 14.3011 11.5 14.5ZM11.5 19.75V21.25C11.5 21.4489 11.421 21.6397 11.2803 21.7803C11.1397 21.921 10.9489 22 10.75 22C10.5511 22 10.3603 21.921 10.2197 21.7803C10.079 21.6397 10 21.4489 10 21.25V19.75C10 19.5511 10.079 19.3603 10.2197 19.2197C10.3603 19.079 10.5511 19 10.75 19C10.9489 19 11.1397 19.079 11.2803 19.2197C11.421 19.3603 11.5 19.5511 11.5 19.75ZM14.5 19.75V21.25C14.5 21.4489 14.421 21.6397 14.2803 21.7803C14.1397 21.921 13.9489 22 13.75 22C13.5511 22 13.3603 21.921 13.2197 21.7803C13.079 21.6397 13 21.4489 13 21.25V19.75C13 19.5511 13.079 19.3603 13.2197 19.2197C13.3603 19.079 13.5511 19 13.75 19C13.9489 19 14.1397 19.079 14.2803 19.2197C14.421 19.3603 14.5 19.5511 14.5 19.75Z" fill="#165DFB"/>
            </svg>' :show-info-icon="true" type="agency" description="Your favorite agencies who get priority notifications"
    :items="agencies" :selected="formsData.shiftForm.more_option_agency.value.agencies"
    search-placeholder="Search agency"
    @update:selected="updateAgencies" @show-details="showAgencyDetails" />

  <ProfessionalSelectionDrawer v-model="internalDrawer" :title="currentPoolOption?.label || 'Internal Pool'"
    icon='<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="8" fill="#DEFAF9"/><path d="M19.4442 23.9995V22.2217C19.4442 21.2787 19.0696 20.3744 18.4028 19.7076C17.736 19.0408 16.8316 18.6662 15.8886 18.6662H10.5553C9.61232 18.6662 8.70795 19.0408 8.04115 19.7076C7.37436 20.3744 6.99976 21.2787 6.99976 22.2217V23.9995M19.4442 8.11328C20.2067 8.31094 20.8819 8.75618 21.3639 9.37911C21.8459 10.002 22.1075 10.7674 22.1075 11.5551C22.1075 12.3427 21.8459 13.1081 21.3639 13.731C20.8819 14.3539 20.2067 14.7992 19.4442 14.9968M24.7775 23.9995V22.2217C24.7769 21.4339 24.5147 20.6686 24.0321 20.046C23.5494 19.4234 22.8737 18.9787 22.1109 18.7817" stroke="#00B7AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.2221 15.1111C15.1857 15.1111 16.7776 13.5192 16.7776 11.5556C16.7776 9.59188 15.1857 8 13.2221 8C11.2584 8 9.6665 9.59188 9.6665 11.5556C9.6665 13.5192 11.2584 15.1111 13.2221 15.1111Z" stroke="#00B7AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    description="Professionals in this internal pool" :items="internalDrawerLocums" :show-info-icon="false" type="internal"
    :selected="formsData.shiftForm.more_option_internal_pools[currentPool]?.value.locums || []"
    @update:selected="(selected) => updateInternal(selected, currentPool)" />

</template>

<script>
import {
  DatePicker,
  // Calendar
} from "@/components/v-calendar";
import CalendarComp from "@/components/Calendar/Calendar";
import {
  ref,
  // reactive,
  onMounted,
  inject,
  computed,
  // nextTick
  watch,
  getCurrentInstance,
  reactive,
  onBeforeMount
} from "vue";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { IonDatetime, IonItem } from "@ionic/vue";
import VueMultiselect from "vue-multiselect";
import { useStore } from "vuex";
import {
  useRouter,
  useRoute
  // useRoute
} from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import { ElMessage } from "@/components/Vendor/Element";
import IMaskDirective from "@/directives/vue-imask/directive";
import CommonRadio from '../../../views/Job/Create/ShiftVisibility/CommonRadio.vue';
import ProfessionalSelectionDrawer from "../../../views/Job/Create/ShiftVisibility/ProfessionalSelectionDrawer.vue";
import { reject } from "lodash";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import distanceInMiles from "@/helpers/distance/distance-in-miles.js";
import { pluralizeWord } from '@/helpers/utility/pluralize';
export default {
  components: {
    IonDatetime,
    IonItem,
    VueMultiselect,
    "v-date-picker": DatePicker,
    CommonRadio,
    ProfessionalSelectionDrawer
  },
  props: {
    modalName: {
      type: String,
    },
    options: {
      type: Object,
    },
  },
  directives: {
    imask: IMaskDirective,
  },
  setup(props) {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();
    const $moment = inject(["$moment"]);
    const $mitt = inject("$mitt");
    const message = inject("messages");
    const modalVisible = ref(false);
    const showInputField = ref(false);
    const isAustralia = isAustraliaRegion();
    const instance = getCurrentInstance();
    const appName = process.env.VUE_APP_APP_NAME;
    // const subscription = ref(
    //   userRootData.calculatedSubscriptions.subscription ? userRootData.calculatedSubscriptions.subscription : false
    // );
    // console.log('sub', subscription)
    function handleSelectChange(value) {

      if (value === 3) {
        showInputField.value = true;
        formsDataArray.shiftForm.max_travel_amount.validators = [
          {
            validator: (rule, formField, callback) => {
              formValidate.validate(
                rule,
                formField,
                "maxTravelAmount",
                callback,
                setFormValidation
              );
            },
          },
        ];
        checkFormValidation("shiftForm", true);
      } else {
        if (formsDataArray.shiftForm.max_travel_amount) {
          delete formsDataArray.shiftForm.max_travel_amount.validators;
          checkFormValidation("shiftForm", true);
        }
      }
      formHooks(formsDataArray)
    }

    const samePayRate = ref(false);
    const job = computed(() => {
      return props.options.job;
    });

    const selectedInternalPoolOption = ref(null);
    const guestLocums = ref([]);
    const agencies = ref([]);
    const preferedLocums = ref([]);
    const internalEmployeeGroups = ref([]);
    const jobCreatePageData = $store.getters.getJobCreatePageData;
    const userRootData = $store.getters.GET_USER_DATA;
    const user = userRootData.shiftVisibilityPercent;
    const agenciesAvailable = userRootData.agencies.length > 0 ? true : false;
    const internalStaffAvailable = userRootData.internalStaffs.length > 0 ? true : false;
    const preferedLocumAvailable = userRootData.preferredLocum.length > 0 ? true : false;
    const visibilityAgencyUser = user.visibilityAgencyUser ? user.visibilityAgencyUser : null;
    const visibilityAllLocum = user.visibilityAllLocum ? user.visibilityAllLocum : null;
    const visibilityInternalStaff = user.visibilityInternalStaff ? user.visibilityInternalStaff : null;
    const visibilityPreferredLocum = user.visibilityPreferredLocum ? user.visibilityPreferredLocum : null;
    const prevVisibilityStatus = ref([]);
    const enableTabClick = ref(false);
    const selectedAgency = ref(null);
    const subscription = ref(userRootData.calculatedSubscriptions.subscription ? userRootData.calculatedSubscriptions.subscription : false);
    const subscriptionAvailiabilityText = ref(userRootData.calculatedSubscriptions.subscriptionAvailiabilityText);

   

    // check if pharmacy is in group and group have active subscription
    const pharmacyIsInGroupAndGroupHaveSubscription = ref(
      userRootData.pharmacyGroupHasSubscription &&
        userRootData.pharmacyGroupHasSubscription.subscription
        ? userRootData.pharmacyGroupHasSubscription.subscription
        : false
    );

    const pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText = ref(
      userRootData.pharmacyGroupHasSubscription?.subscriptionAvailabilityText
    );

    // If pharmacy have subscription but group don't have subscription then show the pharmacy subscription availability text
    if (subscription.value === true && pharmacyIsInGroupAndGroupHaveSubscription.value === false) {
      pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText.value = subscriptionAvailiabilityText.value;
    }

    const isPreferredLocumEnabled = userRootData.settings?.preferredLocumEnabled;

    const onboardingFeature = process.env.VUE_APP_FEATURE_ONBOARD_LOCUM_AS_AN_EMPLOYEE;


    const preferedRadioSelection = ref('notify_all')
    const agencyRadioSelection = ref('notify_all')
    const internalRadioSelection = ref('notify_all')
    const preferedDrawer = ref(false);
    const agencyDrawer = ref(false);
    const internalDrawer = ref(false);
    const currentDetails = ref(null);
    const detailsTitle = ref('');
    const currentPool = ref(null);
    const internalDrawerLocums = ref([]);
    const isButtonEnabled = computed(() => !isNextButtonDisabled.value);
    const currentPoolOption = computed(() =>
      visibiltyOptions.find(opt => opt.value === currentPool.value)
    );


    // Stores individual radio selections for each pool
    const poolRadioSelections = reactive({});

    // Helper to initialize pool radio state
    // const initPoolRadioState = (poolId) => {
    //     poolRadioSelections[poolId] = 'notify_all'; // Default value
    // };

    const initPoolRadioState = (poolId) => {
      const poolData = formsData.shiftForm.more_option_internal_pools[poolId];
      console.log("🚀 ~ initPoolRadioState ~ poolData:", poolData)

      // // Check if this pool has any locums selected
      // const hasLocums = poolData?.value?.locums?.length > 0;

      // // Set the initial radio state
      // poolRadioSelections.value[poolId] = ref(
      //     hasLocums ? 'choose_specific' : 'notify_all'
      // );


    };


 const cancelClick = () => {
            preferedDrawer.value = false;
        };

    const selectedAgencyData = ref({
      name: '',
      email: '',
      rates: '',
      notes: ''
    });

    const showDialog = ref(false);

    const visibiltyOptions = reactive([
      {
        label: `Preferred ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false)}`,
        value: 2,
        description: `Your preferred ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false)}s (Internal or External)`,
        radioOption: "prefered_locum",
        percent: visibilityPreferredLocum,
        visibility: preferedLocumAvailable,
        noLocum: "Preferred locum not available",
        radioSelection: "notify_all",
        icon: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect width="32" height="32" rx="8" fill="#FFF6DE" />
                            <path
                                d="M15.9546 5.57036C15.7925 5.57783 15.6365 5.63444 15.5073 5.73268C15.378 5.83091 15.2818 5.96612 15.2312 6.12036L13.0671 12.7344L6.10933 12.7485C5.9409 12.7491 5.77696 12.8028 5.64084 12.902C5.50473 13.0012 5.4034 13.1408 5.35128 13.301C5.29916 13.4611 5.29892 13.6337 5.35058 13.794C5.40225 13.9543 5.50319 14.0942 5.63902 14.1938L11.2609 18.2954L9.1234 24.9188C9.07184 25.0792 9.07224 25.2518 9.12455 25.412C9.17686 25.5722 9.27841 25.7117 9.41471 25.8108C9.55101 25.9099 9.71512 25.9634 9.88362 25.9637C10.0521 25.964 10.2164 25.9111 10.3531 25.8125L15.9906 21.7329L21.6296 25.8125C21.7663 25.9111 21.9306 25.964 22.0991 25.9637C22.2676 25.9634 22.4317 25.9099 22.568 25.8108C22.7043 25.7117 22.8059 25.5722 22.8582 25.412C22.9105 25.2518 22.9109 25.0792 22.8593 24.9188L20.7218 18.2954L26.3437 14.1938C26.4795 14.0942 26.5805 13.9543 26.6321 13.794C26.6838 13.6337 26.6836 13.4611 26.6314 13.301C26.5793 13.1408 26.478 13.0012 26.3419 12.902C26.2058 12.8028 26.0418 12.7491 25.8734 12.7485L18.914 12.7344L16.7515 6.12036C16.697 5.9542 16.5896 5.81046 16.4457 5.71113C16.3018 5.6118 16.1293 5.56236 15.9546 5.57036ZM15.9906 8.94379L17.5734 13.7829C17.6257 13.9431 17.7273 14.0826 17.8637 14.1817C18.0001 14.2807 18.1642 14.3342 18.3328 14.3344L23.4234 14.3438L19.3109 17.3438C19.175 17.4432 19.0738 17.5829 19.0219 17.7431C18.97 17.9033 18.97 18.0758 19.0218 18.236L20.5859 23.0829L16.4593 20.0969C16.3229 19.9983 16.1589 19.9452 15.9906 19.9452C15.8223 19.9452 15.6582 19.9983 15.5218 20.0969L11.3984 23.0813L12.9609 18.236C13.0127 18.0758 13.0127 17.9033 12.9608 17.7431C12.9089 17.5829 12.8078 17.4432 12.6718 17.3438L8.55933 14.3438L13.65 14.3344C13.8182 14.3339 13.982 14.2802 14.1181 14.1812C14.2541 14.0822 14.3555 13.9428 14.4078 13.7829L15.9906 8.94379Z"
                                fill="#FFB800" />
                        </svg>`,
        locumsCount:preferedLocums?.length || 0,
      },
      {
        label: `${appName} Marketplace`,
        value: 3,
        description: `Available to all registered ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false)}s on the ${appName} marketplace`,
        radioOption: "open_marketplace",
        percent: visibilityAllLocum,
        visibility: true,
        groupTitle: "External Pool",
        groupSubText: "Professionals outside your network",
        radioSelection: "notify_all",
        icon: `<svg class="" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2645 13.2528V2.40967H12.6501V16.8672H21.686V13.2528H16.2645Z" style="fill: rgb(var(--locumate-clr-logo));"></path>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.61435 14.4574C3.61435 8.46897 8.46897 3.61435 14.4574 3.61435C20.4459 3.61435 25.3005 8.46897 25.3005 14.4574C25.3005 20.446 20.4459 25.3005 14.4574 25.3005C8.46897 25.3005 3.61435 20.446 3.61435 14.4574ZM0 14.4574C0 6.47281 6.47283 0 14.4574 0C22.442 0 28.9149 6.47281 28.9149 14.4574C28.9149 17.7985 27.7816 20.8746 25.8785 23.3227L32 29.4442L29.4442 32L23.3229 25.8785C20.8746 27.7816 17.7984 28.9149 14.4574 28.9149C6.47281 28.9149 0 22.4421 0 14.4574Z" style="fill: rgb(var(--locumate-clr-logo-dark));"></path>
    </svg>
`
      },
      {
        label: "Agency",
        value: 4,
        description: "Notify all preferred agencies",
        radioOption: "agency",
        percent: visibilityAgencyUser,
        visibility: agenciesAvailable,
        noLocum: "Agencies not available. Please contact your  group manager",

        groupTitle: "External Pools",
        groupSubText: "Professionals outside your network",
        radioSelection: "notify_all",
        icon: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="8" fill="#DBEAFE"/>
<path d="M26.5 23.5H25V13C25 12.6022 24.842 12.2206 24.5607 11.9393C24.2794 11.658 23.8978 11.5 23.5 11.5H17.5V7C17.5002 6.72837 17.4266 6.46179 17.2871 6.22872C17.1476 5.99564 16.9474 5.80482 16.708 5.67661C16.4685 5.54841 16.1987 5.48764 15.9274 5.50078C15.6561 5.51393 15.3935 5.60049 15.1675 5.75125L7.6675 10.75C7.46176 10.8873 7.29315 11.0733 7.17669 11.2915C7.06023 11.5097 6.99953 11.7533 7 12.0006V23.5H5.5C5.30109 23.5 5.11032 23.579 4.96967 23.7197C4.82902 23.8603 4.75 24.0511 4.75 24.25C4.75 24.4489 4.82902 24.6397 4.96967 24.7803C5.11032 24.921 5.30109 25 5.5 25H26.5C26.6989 25 26.8897 24.921 27.0303 24.7803C27.171 24.6397 27.25 24.4489 27.25 24.25C27.25 24.0511 27.171 23.8603 27.0303 23.7197C26.8897 23.579 26.6989 23.5 26.5 23.5ZM23.5 13V23.5H17.5V13H23.5ZM8.5 12.0006L16 7V23.5H8.5V12.0006ZM14.5 14.5V16C14.5 16.1989 14.421 16.3897 14.2803 16.5303C14.1397 16.671 13.9489 16.75 13.75 16.75C13.5511 16.75 13.3603 16.671 13.2197 16.5303C13.079 16.3897 13 16.1989 13 16V14.5C13 14.3011 13.079 14.1103 13.2197 13.9697C13.3603 13.829 13.5511 13.75 13.75 13.75C13.9489 13.75 14.1397 13.829 14.2803 13.9697C14.421 14.1103 14.5 14.3011 14.5 14.5ZM11.5 14.5V16C11.5 16.1989 11.421 16.3897 11.2803 16.5303C11.1397 16.671 10.9489 16.75 10.75 16.75C10.5511 16.75 10.3603 16.671 10.2197 16.5303C10.079 16.3897 10 16.1989 10 16V14.5C10 14.3011 10.079 14.1103 10.2197 13.9697C10.3603 13.829 10.5511 13.75 10.75 13.75C10.9489 13.75 11.1397 13.829 11.2803 13.9697C11.421 14.1103 11.5 14.3011 11.5 14.5ZM11.5 19.75V21.25C11.5 21.4489 11.421 21.6397 11.2803 21.7803C11.1397 21.921 10.9489 22 10.75 22C10.5511 22 10.3603 21.921 10.2197 21.7803C10.079 21.6397 10 21.4489 10 21.25V19.75C10 19.5511 10.079 19.3603 10.2197 19.2197C10.3603 19.079 10.5511 19 10.75 19C10.9489 19 11.1397 19.079 11.2803 19.2197C11.421 19.3603 11.5 19.5511 11.5 19.75ZM14.5 19.75V21.25C14.5 21.4489 14.421 21.6397 14.2803 21.7803C14.1397 21.921 13.9489 22 13.75 22C13.5511 22 13.3603 21.921 13.2197 21.7803C13.079 21.6397 13 21.4489 13 21.25V19.75C13 19.5511 13.079 19.3603 13.2197 19.2197C13.3603 19.079 13.5511 19 13.75 19C13.9489 19 14.1397 19.079 14.2803 19.2197C14.421 19.3603 14.5 19.5511 14.5 19.75Z" fill="#165DFB"/>
</svg>
`,
locumsCount:agencies?.length ? agencies?.length : 0,
      },
    ]);

    const visibiltyAccessOptions = reactive([
      {
        label: "First Come, First Served",
        value: "0",
        description: `${instance?.appContext.config.globalProperties.$filters.systemLocumName(true, false)}s can "take" the shift`,
        radioOption: "first_come_first_served",
        visibility: false,
        doesSubscriptionEffect: false,
      },
      {
        label: "Apply when outside of radius",
        value: 2,
        description: `Useful for regional pharmacies wanting to negotiate with Locum's outside of a specific radius e.g. ${distanceInMiles(200, 'km', false)}`,
        radioOption: "apply_radius",
        visibility: false,
        doesSubscriptionEffect: false,
      },
      {
        label: "Always Apply",
        value: 1,
        description: `All ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false)}s must apply for the shift`,
        radioOption: "always_apply",
        visibility: false,
        doesSubscriptionEffect: subscription.value == false ? true : false,

      },
    ]);

    const radiusAccessValue = [
      {
        value: 50,
        label: distanceInMiles(50, 'km', false),
      },
      {
        value: 100,
        label: distanceInMiles(100, 'km', false),
      },
      {
        value: 200,
        label: distanceInMiles(200, 'km', false),
      },
      {
        value: 300,
        label: distanceInMiles(300, 'km', false),
      },
      {
        value: 500,
        label: distanceInMiles(500, 'km', false),
      },
    ];

    const shift = computed(() => {
      return props.options.shift;
    });
    const bottomDropUp = ref(false);

    $mitt.on(props.modalName, (options) => {
      modalVisible.value = options.show;
    });
    const languages = ref([]);
    const languagesList = $store.getters.getLanguagesList;
    const calendarRef = ref(null);
    // const disabledDates = ref([]);

    Object.keys(languagesList).forEach((key) => {
      const language = {
        title: languagesList[key],
        desc: key,
        flag: key.split("_")[1] ? key.split("_")[1].toLowerCase() : false,
        show: true,
        $isDisabled: key.split("_")[1] ? false : true,
      };

      languages.value.push(language);
    });

    const customLabel = ({ title, desc }) => {
      return `${title} – ${desc}`;
    };

    const selectOptions = (selectedOption, id) => {
      setOption(selectedOption, id);

      formsData.shiftForm.languages.value[id] = selectedOption.desc;
      checkFormValidation("shiftForm", true);
    };

    const addEmptyOption = (id, remove) => {
      function addOption(id) {
        formsData.shiftForm.languages.selectValue.push(null);
        formsData.shiftForm.languages.options.push(null);
        formsData.shiftForm.languages.options[id] = languages.value.filter(
          (x) => x.show
        );
      }

      if (remove && languages.value.every((x) => x.show == false)) {
        addOption(id);
      } else if (!remove && languages.value.some((x) => x.show == true)) {
        addOption(id);
      }
    };

    const removeOption = (id) => {
      if (formsData.shiftForm.languages.selectValue.length > 1) {
        addEmptyOption(formsData.shiftForm.languages.options.length + 1, true);

        languages.value.some((x) => {
          if (formsData.shiftForm.languages.selectValue[id].desc == x.desc) {
            x.show = true;
            return true;
          }
        });
        formsData.shiftForm.languages.options.splice(id, 1);
        formsData.shiftForm.languages.selectValue.splice(id, 1);
        formsData.shiftForm.languages.value.splice(id, 1);
      } else {
        languages.value.some((x) => {
          if (formsData.shiftForm.languages.selectValue[id].desc == x.desc) {
            x.show = true;
            return true;
          }
        });
        formsData.shiftForm.languages.selectValue[id] = null;
      }
      setOptionsValue();
      checkFormValidation("shiftForm", true);
    };

    const setOption = (lang, id) => {
      if (lang.desc == "Remove") {
        console.log(id);
      } else if (id !== undefined) {
        languages.value.some((x) => {
          if (lang.desc == x.desc) {
            x.show = false;
            return true;
          }
        });

        if (formsData.shiftForm.languages.selectValue[id] != null) {
          languages.value.some((x) => {
            if (formsData.shiftForm.languages.selectValue[id].desc == x.desc) {
              x.show = true;
              return true;
            }
          });
        } else {
          addEmptyOption(id + 1);
        }

        languages.value.some((x) => {
          if (lang.desc == x.desc) {
            x.show = false;
            formsData.shiftForm.languages.selectValue[id] = lang;
            return true;
          }
        });

        formsData.shiftForm.languages.options[id] = languages.value.filter(
          (x) => x.show
        );

        if (formsData.shiftForm.languages.selectValue[id] != null) {
          formsData.shiftForm.languages.remove.push(true);
        }
      } else {
        lang.forEach((element, i) => {
          languages.value.some((x) => {
            if (element == x.desc) {
              x.show = false;
              if (formsData.shiftForm.languages.selectValue[i] !== undefined) {
                formsData.shiftForm.languages.selectValue[i] = x;
              } else {
                formsData.shiftForm.languages.selectValue.push(x);
              }
              return true;
            }
          });
          // formsData.shiftForm.languages.options[i] = languages.value.filter(x => x.show)
          formsData.shiftForm.languages.options[i] = languages.value.filter(
            (x) => x.show
          );
        });

        lang.forEach((element, i) => {
          formsData.shiftForm.languages.options[i] = languages.value.filter(
            (x) => x.show
          );
          if (formsData.shiftForm.languages.selectValue[id] != null) {
            formsData.shiftForm.languages.remove.push(true);
          }
        });

        if (formsData.shiftForm.languages.value[0] != null) {
          addEmptyOption(formsData.shiftForm.languages.options.length);
        }
      }

      setOptionsValue();
    };

    const setOptionsValue = () => {
      formsData.shiftForm.languages.options.forEach((option, i) => {
        formsData.shiftForm.languages.options[i] = languages.value.filter(
          (x) => x.show
        );
        if (formsData.shiftForm.languages.selectValue[i] != null) {
          formsData.shiftForm.languages.remove[i] = true;
        } else {
          formsData.shiftForm.languages.remove[i] = false;
        }
      });
    };

    const { disabledDates, calendarAttrs } = CalendarComp(
      calendarRef,
      job.value.shifts,
      {
        attrs: ["today", "shiftsAsDots"],
        changePathParams: false,
        setDaySelected: false,
        // disabledDates: disabledDates
      }
    );

    const setDisabledDates = () => {
      disabledDates.value = [];
      (job.value?.shifts || []).forEach((jobShift) => {
        if (jobShift.date != shift.value.date) {
          // disabledDates.value.splice(i, 1)
          disabledDates.value.push(jobShift.date);
        }
      });
    };

    const formsDataArray = reactive({
      shiftForm: {
        shiftDate: {
          ref: null,
          value: null,
          mask: formMasks.jobDate(false),
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  {
                    rule: "shiftDate",
                    options: {
                      minDate: $moment().format("DD/MM/YYYY"),
                    },
                  },
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        isBlockShift: {
          value: false
        },
        shiftTime: {
          value: {
            timeStart: null,
            timeEnd: null,
          },
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "timeRange",
                  callback,
                  setFormValidation
                );
              },
            },
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "currentTimeLater",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        rate: {
          value: {
            minRate: null,
            maxRate: null,
          },
          mask: formMasks.rate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "rateRange",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        language_conditions: {
          value: jobCreatePageData.language_conditions
            ? jobCreatePageData.language_conditions
            : false,
        },
        languages: {
          value: [null],
          selectValue: [null],
          options: [],
          remove: [false],
        },
        platform_role_id: {
          value: jobCreatePageData.platform_role_id
            ? jobCreatePageData.platform_role_id
            : 1,
        },
        covid_cert_required: {
          value: jobCreatePageData.covid_cert_required
            ? jobCreatePageData.covid_cert_required
            : 0,
        },
        // =====================================================
        paying_for_travel: {
          value: jobCreatePageData.paying_for_travel
            ? jobCreatePageData.paying_for_travel
            : 0,
        },
        max_travel_amount: {
          value: jobCreatePageData.max_travel_amount
            ? jobCreatePageData.max_travel_amount
            : 0,
        },
        round_trip: {
          value: jobCreatePageData.round_trip
            ? jobCreatePageData.round_trip
            : 0,
        },
        enable_travel_allowance_for_first_and_last_day: {
          value: jobCreatePageData.enable_travel_allowance_for_first_and_last_day
            ? jobCreatePageData.enable_travel_allowance_for_first_and_last_day
            : false,
        },
        pay_for_flights: {
          value: jobCreatePageData.pay_for_flights
            ? jobCreatePageData.pay_for_flights
            : false,
        },
        pay_for_accommodation: {
          value: jobCreatePageData.pay_for_accomodation
            ? jobCreatePageData.pay_for_accomodation
            : false,
        },
        // =====================================================
        solo: {
          value: jobCreatePageData.solo == 1 ? true : false,
        },
        number_of_technicians: {
          value: jobCreatePageData.number_of_technicians
            ? jobCreatePageData.number_of_technicians
            : false,
        },
        num_of_tech: {
          ref: {},
          valueTemp: "",
          value: jobCreatePageData.num_of_tech
            ? jobCreatePageData.num_of_tech
            : "",
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "numOfTech",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        additional_notes: {
          value: jobCreatePageData.additional_notes
            ? jobCreatePageData.additional_notes
            : false,
        },
        notes: {
          value: jobCreatePageData.notes ? jobCreatePageData.notes : null,
        },
        open_up: {
          value: jobCreatePageData.open_up ? jobCreatePageData.open_up : false,
        },
        close: {
          value: jobCreatePageData.close ? jobCreatePageData.close : false,
        },
        admin_aids: {
          value: jobCreatePageData.admin_aids == 1 ? true : false,
        },
        home_med_review: {
          value: jobCreatePageData.home_med_review == 1 ? true : false,
        },
        parking_check: {
          value: jobCreatePageData.parking_check
            ? jobCreatePageData.parking_check
            : false,
        },
        parking: {
          value: jobCreatePageData.parking ? jobCreatePageData.parking : null,
        },
        visibility_status: {
          value: jobCreatePageData.visibility_status
            ? jobCreatePageData.visibility_status
            : [],
        },
        // more_option_internal_pool:{
        //   value: jobCreatePageData.more_option_internal_pool
        //     ? jobCreatePageData.more_option_internal_pool
        //     :null,
        // },
        more_option_internal_pools: {},
        more_option_prefered_locum: {
          value: {
            value: jobCreatePageData.more_option_prefered_locum.value
              ? jobCreatePageData.more_option_prefered_locum.value
              : null,
            locums: jobCreatePageData.more_option_prefered_locum.locums
              ? jobCreatePageData.more_option_prefered_locum.locums : []
          }
        },
        more_option_open_marketplace: {
          value: {
            value: jobCreatePageData.more_option_open_marketplace.value
              ? jobCreatePageData.more_option_open_marketplace.value
              : null,
            onboarding: jobCreatePageData.more_option_open_marketplace.onboarding ? 1 : 0,
          }
        },
        more_option_agency: {
          value: {
            value: jobCreatePageData.more_option_agency.value
              ? jobCreatePageData.more_option_agency.value
              : null,
            agencies: jobCreatePageData.more_option_agency.agencies
              ? jobCreatePageData.more_option_agency.agencies
              : [],
          },
        },
        shift_application_type: {
          value: jobCreatePageData.shift_application_type ? jobCreatePageData.shift_application_type : '0',
        },
        application_radius: {
          value: jobCreatePageData.application_radius ? jobCreatePageData.application_radius : null,
        },
      },
    });

    async function getGuestLocums() {
      const allGuestLocums = await $store.dispatch("GET_GUEST_LOCUMS_LIST");
      guestLocums.value = allGuestLocums.data;
    }

    async function getAgencies() {
      const allAgencies = await $store.dispatch("GET_AGENCIES");
      agencies.value = allAgencies.data;
    }

    async function getPreferedLocums() {
      const allPreferedLocums = await $store.dispatch("GET_PREFERED_LOCUMS_LIST");
      preferedLocums.value = allPreferedLocums.data;

    }
    async function getInternalEmployeeGroups() {
      const allInternalEmployeeGroups = await $store.dispatch("GET_INTERNAL_EMPLOYEE_GROUPS");
      internalEmployeeGroups.value = allInternalEmployeeGroups.data;
    }

    // const agencyValue = computed({
    //   get: () => formsData.shiftForm.more_option_agency.value.value,
    //   set: (newValue) => (formsData.shiftForm.more_option_agency.value.value = newValue),
    // });

    function handleCheckboxClick(agencyId) {
      if (!formsData.shiftForm.more_option_agency.value.agencies.includes(agencyId)) {
        const selected = agencies.value.find((agency) => agency.id === agencyId);
        if (selected) {
          selectedAgencyData.value = {
            name: selected.name,
            email: selected.email,
            rates: selected.rate,
            notes: selected.notes,
          };
          showDialog.value = true;
        }
      }
    }

    // function handleCheckboxClickGuestLocum(guestLocumId) {
    //     if(!formsData.shiftForm.more_option_internal_pool.value.guestLocums.includes(guestLocumId)){
    //       const selected = guestLocums.value.find((guestLocum) => guestLocum.id === guestLocumId);
    //       if (selected) {
    //         console.log('hello Guest Locums', selected)
    //         selectedAgencyData.value = {
    //           name: selected.name,
    //           email: selected.email,
    //         };
    //         showDialog.value = true;
    //       }
    //     }
    // }

    const handleCheckboxClickForOnboarding = () => {
      formsData.shiftForm.more_option_open_marketplace.value.onboarding = !formsData.shiftForm.more_option_open_marketplace.value.onboarding;
    }

     const shouldDisableCheckbox = (visibilityOption) => {
            // Handle dynamic pools
            
            if (visibilityOption.isDynamicPool) {
                // New edge case: Group structure without subscription
                if (visibilityOption?.poolData?.structure?.name === 'Group' && !subscription.value) {
                    return true; // disable the checkbox
                }

                // Check locumsCount - disable if 0, enable if > 0
                if (visibilityOption.locumsCount === 0) {
                    return true; // disable if no locums
                }
                return false;
            }


            if (visibilityOption.value == 4 && agencies.value.length < 1) {
                return true; // disable the checkbox
            }
            
            if (visibilityOption.visibility && subscription.value && visibilityOption.value !== 2) {
                return false; // Disable the checkbox
            }

            // Exception for "Open Marketplace" option
            if (visibilityOption.value === 3) {
                return false; // Enable the checkbox
            }

            // check if pharmacy have preferred locum and preferred locum is enabled
            if (visibilityOption.value === 2 &&
                visibilityOption.visibility &&
                isPreferredLocumEnabled
            ) {
              return false;
            }

            return true;
        };

    function calculateHourValue(futureDateStr, percentage) {
      if(!futureDateStr || !percentage) return null;

      // Convert the percentage to a decimal value
      const decimalPercentage = percentage / 100;

      // Split the date string into day, month, and year components
      const [day, month, year] = futureDateStr.split("/");

      // Create a new Date object using the day, month, and year
      const futureDate = new Date(`${year}-${month}-${day}`);

      // Get the current date and time
      const currentDate = new Date();

      // Calculate the time difference in milliseconds between the future date and the current date
      const timeDifference = futureDate.getTime() - currentDate.getTime();

      // Calculate the total hours from the time difference with three decimal places
      const totalHours = timeDifference / (1000 * 60 * 60);

      // Calculate the hour value based on the percentage
      const hourValue = totalHours * decimalPercentage;

      return parseFloat(hourValue.toFixed(0));
    }

      const updateVisibilityOptions = (selectedOptions) => {
            console.log("🚀 ~ updateVisibilityOptions ~ selectedOptions:", selectedOptions);
            const previouslySelectedOptions = prevVisibilityStatus.value;

            // Determine deselected options
            const lastDeselectedValue = previouslySelectedOptions.filter(
                (option) => !selectedOptions.includes(option)
            );

            // Determine newly selected options
            const lastSelectedValue = selectedOptions.filter(
                (option) => !previouslySelectedOptions.includes(option)
            );

            // Handle selected options
            if (lastSelectedValue.length > 0) {
                lastSelectedValue.forEach(selectedValue => {
                    // Check if this is a dynamic pool ID
                    const isDynamicPool = visibiltyOptions.some(opt =>
                        opt.isDynamicPool && opt.value === selectedValue
                    );

                    if (isDynamicPool) {
                        // Initialize the pool if it doesn't exist
                        if (!formsData.shiftForm.more_option_internal_pools[selectedValue]) {
                            formsData.shiftForm.more_option_internal_pools[selectedValue] = {
                                value: {
                                    value: calculateHourValue(
                                        jobCreatePageData.dates[0],
                                        visibilityInternalStaff
                                    ),
                                    locums: [],
                                    tags: []
                                }
                            };
                        } else {
                            formsData.shiftForm.more_option_internal_pools[selectedValue].value.value =
                                calculateHourValue(
                                    jobCreatePageData.dates[0],
                                    visibilityInternalStaff
                                );
                        }
                        // Initialize radio selection if not exists
                        if (!poolRadioSelections[selectedValue]) {
                            poolRadioSelections[selectedValue] = 'notify_all';
                        }
                    } else if (selectedValue == 2) {
                        formsData.shiftForm.more_option_prefered_locum.value.value =
                            calculateHourValue(
                                jobCreatePageData.dates[0],
                                visibilityPreferredLocum
                            );
                        formsData.shiftForm.more_option_prefered_locum.value.locums =
                            formsData.shiftForm.more_option_prefered_locum.value.locums || [];
                    } else if (selectedValue == 3) {
                        formsData.shiftForm.more_option_open_marketplace.value.value =
                            calculateHourValue(jobCreatePageData.dates[0], visibilityAllLocum);
                    } else if (selectedValue == 4) {
                        formsData.shiftForm.more_option_agency.value.value =
                            calculateHourValue(
                                jobCreatePageData.dates[0],
                                visibilityAgencyUser
                            );
                        formsData.shiftForm.more_option_agency.value.agencies =
                            formsData.shiftForm.more_option_agency.value.agencies || [];
                    }
                });
            }

            // Handle deselected options
            if (lastDeselectedValue.length > 0) {
                lastDeselectedValue.forEach(deselectedValue => {
                    // Check if this is a dynamic pool ID
                    const isDynamicPool = visibiltyOptions.some(opt =>
                        opt.isDynamicPool && opt.value === deselectedValue
                    );

                    if (isDynamicPool) {
                        if (formsData.shiftForm.more_option_internal_pools[deselectedValue]) {
                            formsData.shiftForm.more_option_internal_pools[deselectedValue].value = {
                                value: null,
                                locums: [],
                                tags: []
                            };
                        }
                        // Reset radio selection
                        poolRadioSelections[deselectedValue] = 'notify_all';
                    } else if (deselectedValue == 2) {
                        formsData.shiftForm.more_option_prefered_locum.value.value = null;
                        formsData.shiftForm.more_option_prefered_locum.value.locums = [];
                    } else if (deselectedValue == 3) {
                        formsData.shiftForm.more_option_open_marketplace.value.value = null;
                    } else if (deselectedValue == 4) {
                        formsData.shiftForm.more_option_agency.value.value = null;
                        formsData.shiftForm.more_option_agency.value.agencies = [];
                    }
                });
            }

            prevVisibilityStatus.value = [...selectedOptions];
        };

    const updateVisibilityAccess = () => {
      const selectedField = formsData.shiftForm.shift_application_type.value;

      if (selectedField === 2) {
        formsData.shiftForm.shift_application_type.value = 2;
        formsData.shiftForm.application_radius.value = radiusAccessValue.find(
          (option) => option.value === selectedField
        )?.value;
      } else if (selectedField === 1) {
        formsData.shiftForm.shift_application_type.value = 1;
        formsData.shiftForm.application_radius.value = null;
      } else if (selectedField === '0') {
        formsData.shiftForm.shift_application_type.value = "0";
        formsData.shiftForm.application_radius.value = null;
      }
    };

    const calendarUpdate = () => {
      dateSelected.value = $moment(
        formsData.shiftForm.shiftDate.value,
        "DD/MM/YYYY"
      ).format();
      checkFormValidation("shiftForm", true);
    };

    const dateSelected = computed({
      get: () => {
        return $moment(
          formsData.shiftForm.shiftDate.value,
          `${instance?.appContext.config.globalProperties.$filters.systemDateFormat()}`
        ).format();
      },
      set: (val) => {
        const date = $moment(val).format(`${instance?.appContext.config.globalProperties.$filters.systemDateFormat()}`);
        formsData.shiftForm.shiftDate.value = date;
        formsData.shiftForm.shiftDate.ref.maskRef.value = date;
        if (formsData.shiftForm.shiftDate.ref) {
          formsData.shiftForm.shiftDate.ref.maskRef.value = date;
        }
        return val;
      },
    });

    watch(calendarRef, () => {
      // setDisabledDates()
      if (!formsRefs.shiftForm.value) {
        setFormRefs();
        checkFormValidation("shiftForm", true);
        copyFormResetValue("shiftForm", true);
      } else {
        checkFormValidation("shiftForm", true);
      }
    });
    const platformRoleOption = ref([]);
    onMounted(async () => {
      setFormRefs();
      setOption(formsData.shiftForm.languages.value);
      getAgencies();
      getPreferedLocums();
      getGuestLocums();
      getInternalEmployeeGroups();
      let platformRoleResponse = await $store.dispatch("GET_PLATFORM_ROLE");
      platformRoleOption.value = platformRoleResponse.data;
    });

    const applyInternalPoolsFromShift = (shiftVisibilities = {}) => {
      const internalPoolsFromShift =
        shiftVisibilities.moreOptionInternalPools ||
        shiftVisibilities.more_option_internal_pools ||
        {};
      console.log("🚀 ~ applyInternalPoolsFromShift ~ internalPoolsFromShift:", internalPoolsFromShift);

      Object.entries(internalPoolsFromShift).forEach(([poolId, poolData]) => {
        // Match dynamic pool option id type (UUID/number) used by visibility checkboxes.
        const poolOption = visibiltyOptions.find(
          (opt) => opt.isDynamicPool && String(opt.value) === String(poolId)
        );
        const formPoolId = poolOption ? poolOption.value : poolId;

        const locums = Array.isArray(poolData?.value)
          ? poolData.value
          : Array.isArray(poolData?.value?.locums)
            ? poolData.value.locums
            : Array.isArray(poolData?.locums)
              ? poolData.locums
              : [];

        const tags = Array.isArray(poolData?.value?.tags)
          ? poolData.value.tags
          : Array.isArray(poolData?.tags)
            ? poolData.tags
            : [];

        const visibilityHours =
          poolData?.value?.value !== undefined
            ? poolData.value.value
            : poolData?.value !== undefined && !Array.isArray(poolData.value)
              ? poolData.value
              : null;

        if (!formsData.shiftForm.more_option_internal_pools[formPoolId]) {
          formsData.shiftForm.more_option_internal_pools[formPoolId] = {
            value: { value: null, locums: [], tags: [] },
          };
        }

        formsData.shiftForm.more_option_internal_pools[formPoolId] = {
          value: {
            locums: [...locums],
            tags: [...tags],
            value: visibilityHours,
          },
        };

        poolRadioSelections[formPoolId] =
          locums.length > 0 ? "choose_specific" : "notify_all";
      });
    };

    const openModal = () => {
      try {
      setFormRefs();
      checkFormValidation("shiftForm", true);

      // Light pharmacy shift list omits nested `job`; parent passes full job via options.job.
      const shiftJob = { ...(shift.value?.job || job.value || {}) };
      console.log("🚀 ~ openModal ~ shiftJob:", shiftJob)
      const shiftSettings = { ...(shiftJob.settings || {}) };
      console.log("🚀 ~ openModal ~ shiftSettings:", shiftSettings)
      const shiftVisibilities = shift.value?.visibilities || {};
      const dayOfWeek = $moment(shift.value.date, "YYYY-MM-DD").format("dddd");
      prevVisibilityStatus.value = shiftVisibilities.visibilityStatus ? shiftVisibilities.visibilityStatus : [];
      formsData.shiftForm.shiftDate.value = $moment(
        shift.value.date,
        ["YYYY-MM-DD", "YYYY/MM/DD", "DD MMM YYYY", "D MMM YYYY", "d M Y"]
      ).format(`${instance?.appContext.config.globalProperties.$filters.systemDateFormat()}`);
      // dateSelected.value = $moment(formsData.shiftForm.shiftDate.value, 'DD/MM/YYYY').format();
      formsData.shiftForm.shiftTime.value.timeStart = $moment(
        shift.value.startTime,
        ["H:mm"]
      ).format();
      formsData.shiftForm.shiftTime.value.timeEnd = $moment(
        shift.value.endTime,
        ["H:mm"]
      ).format();

      // shift.value.payRateMinForced - KEY FOR OVERWRITE VALUE THROUGH ADMIN PANEL, NOT USED NOW
      if (dayOfWeek === "Saturday") {
        formsData.shiftForm.rate.value.minRate = shiftJob.weekendMinRate ? shiftJob.weekendMinRate : shiftJob.saturdayMinRate ? shiftJob.saturdayMinRate : null;
      } else if (dayOfWeek === "Sunday") {
        formsData.shiftForm.rate.value.minRate = shiftJob.weekendMinRate ? shiftJob.weekendMinRate : shiftJob.sundayMinRate ? shiftJob.sundayMinRate : null;
      } else {
        formsData.shiftForm.rate.value.minRate = shiftJob.minRate
          ? shiftJob.minRate
          : shiftJob.weekendMinRate
            ? shiftJob.weekendMinRate
            : shiftJob.saturdayMinRate
              ? shiftJob.saturdayMinRate
              : shiftJob.sundayMinRate
                ? shiftJob.sundayMinRate
                : null;
      }

      if (
        shiftSettings.parking &&
        shiftSettings.parking !== ""
      ) {
        formsData.shiftForm.parking_check.value = true;
        formsData.shiftForm.parking.value = shiftSettings.parking;
      }
      // shift.value.payRateMaxForced - KEY FOR OVERWRITE VALUE THROUGH ADMIN PANEL, NOT USED NOW
      // formsData.shiftForm.rate.value.maxRate = shiftJob.maxRate
      //   ? shiftJob.maxRate : shiftJob.weekendMaxRate
      //   ? shiftJob.weekendMaxRate : null;

      if (dayOfWeek === "Saturday") {
        formsData.shiftForm.rate.value.maxRate = shiftJob.weekendMaxRate ? shiftJob.weekendMaxRate : shiftJob.saturdayMaxRate ? shiftJob.saturdayMaxRate : null;
      } else if (dayOfWeek === "Sunday") {
        formsData.shiftForm.rate.value.maxRate = shiftJob.weekendMaxRate ? shiftJob.weekendMaxRate : shiftJob.sundayMaxRate ? shiftJob.sundayMaxRate : null;
      } else {
        formsData.shiftForm.rate.value.maxRate = shiftJob.maxRate
          ? shiftJob.maxRate
          : shiftJob.weekendMaxRate
            ? shiftJob.weekendMaxRate
            : shiftJob.saturdayMaxRate
              ? shiftJob.saturdayMaxRate
              : shiftJob.sundayMaxRate
                ? shiftJob.sundayMaxRate
                : null;
      }

      formsData.shiftForm.platform_role_id.value = shiftJob.platformRoleId ? shiftJob.platformRoleId : null
      formsData.shiftForm.covid_cert_required.value = shiftJob.covidCertRequired ? shiftJob.covidCertRequired : null
      formsData.shiftForm.close.value = shiftSettings.close ? true : false;
      formsData.shiftForm.open_up.value = shiftSettings.openUp ? true : false;
      formsData.shiftForm.solo.value = shiftSettings.solo ? true : false;
      formsData.shiftForm.parking_check.value = shiftSettings.parking ? true : false;
      formsData.shiftForm.parking.value = shiftSettings.parking ? shiftSettings.parking : null;
      formsData.shiftForm.additional_notes.value = shiftSettings.notes ? true : false;
      formsData.shiftForm.notes.value = shiftSettings.notes ? shiftSettings.notes : null;
      formsData.shiftForm.admin_aids.value = shiftSettings.adminAids ? true : false;
      formsData.shiftForm.number_of_technicians.value = shiftSettings.numOfTech ? true : false;
      formsData.shiftForm.num_of_tech.value = shiftSettings.numOfTech ? shiftSettings.numOfTech : null;
      formsData.shiftForm.paying_for_travel.value = shiftSettings.payingForTravel ? shiftSettings.payingForTravel : null;
      formsData.shiftForm.pay_for_accommodation.value = shiftSettings.payForAccommodation ? shiftSettings.payForAccommodation : null;
      formsData.shiftForm.enable_travel_allowance_for_first_and_last_day.value = shiftJob.enableTravelAllowanceForFirstAndLastDay ? shiftJob.enableTravelAllowanceForFirstAndLastDay : null;
      formsData.shiftForm.pay_for_flights.value = shiftSettings.payForFlights ? shiftSettings.payForFlights : null;
      if (formsData.shiftForm.paying_for_travel.value === 3) {
        formsData.shiftForm.max_travel_amount.value = shiftJob.maxTravelCompensation ? shiftJob.maxTravelCompensation : 0;
        formsDataArray.shiftForm.max_travel_amount.validators = [
          {
            validator: (rule, formField, callback) => {
              formValidate.validate(
                rule,
                formField,
                "maxTravelAmount",
                callback,
                setFormValidation
              );
            },
          },
        ];
        checkFormValidation("shiftForm", true);

      } else {
        if (formsDataArray.shiftForm.max_travel_amount) {
          formsData.shiftForm.max_travel_amount.value = 0;
          delete formsDataArray.shiftForm.max_travel_amount.validators;
          checkFormValidation("shiftForm", true);
        }
      }

      formHooks(formsDataArray)
      formsData.shiftForm.language_conditions.value = shiftSettings.languages ? true : false;
      formsData.shiftForm.languages.value = shiftSettings.languages ? shiftSettings.languages : [];
      formsData.shiftForm.isBlockShift.value = shiftJob.isBlockShift == 1 ? true : false;
      const rawVisibilityStatus = shiftVisibilities.visibilityStatus
        || shiftVisibilities.visibility_status
        || [];
      formsData.shiftForm.visibility_status.value = Array.isArray(rawVisibilityStatus)
        ? rawVisibilityStatus.map((status) => {
            const poolOption = visibiltyOptions.find(
              (opt) => opt.isDynamicPool && String(opt.value) === String(status)
            );
            return poolOption ? poolOption.value : status;
          })
        : [];
      formsData.shiftForm.more_option_agency.value.agencies = shiftVisibilities.agencies ? shiftVisibilities.agencies : [];
      agencyRadioSelection.value = formsData.shiftForm.more_option_agency.value.agencies.length > 0 ? 'choose_specific' : 'notify_all';
      formsData.shiftForm.more_option_agency.value.value = shiftVisibilities.moreOptionAgency ? shiftVisibilities.moreOptionAgency : null;
      formsData.shiftForm.more_option_open_marketplace.value.value = shiftVisibilities.moreOptionOpenMarketplace?.value ? shiftVisibilities.moreOptionOpenMarketplace.value : null;
      formsData.shiftForm.more_option_open_marketplace.value.onboarding = shiftVisibilities.moreOptionOpenMarketplace?.onboarding ? true : false;
      
      applyInternalPoolsFromShift(shiftVisibilities);

      formsData.shiftForm.more_option_prefered_locum.value.value = shiftVisibilities.moreOptionPreferredLocum ? shiftVisibilities.moreOptionPreferredLocum : null;
      formsData.shiftForm.more_option_prefered_locum.value.locums = shiftVisibilities.locums ? shiftVisibilities.locums : [];
      preferedRadioSelection.value = formsData.shiftForm.more_option_prefered_locum.value.locums.length > 0 ? 'choose_specific' : 'notify_all';
      formsData.shiftForm.shift_application_type.value = shift.value.shiftApplicationType ? shift.value.shiftApplicationType : '0';
      formsData.shiftForm.application_radius.value = shift.value.applicationRadius ? shift.value.applicationRadius : null;
      formsData.shiftForm.more_option_internal_pool.value.tags = Array.isArray(shiftVisibilities.visibilityTags)
        ? shiftVisibilities.visibilityTags.map(tag => tag.id)
        : [];

      $(".calendar_comp .vc-day.id-" + shift.value.date).click();
      setDisabledDates();
      copyFormResetValue("shiftForm", true);
      checkFormValidation("shiftForm", true);
      setOption(formsData.shiftForm.languages.value);
      } catch (error) {
        console.error("Shift edit openModal failed:", error);
      }
    };
    const closeModal = () => {
      modalVisible.value = false;
    };

    const checkSubscriptionEnabledDIsabled = (visibilityOption) => {
      if (subscription.value) {
        return false;
      }

      // Exception for "Open Marketplace" option
      if (visibilityOption.value === 3) {
        return false;
      }

      // check if pharmacy is in group and group have active subscription for preferred locum option
      if (visibilityOption.value === 2) {
        return false;
      }

      return true;
    }

    const submit = (formName) => {
      const shiftJob = { ...(shift.value?.job || job.value || {}) }
      // const checkofall = shiftJob.weekendMaxRate

      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              checkFormChanged("shiftForm", true);
              const formValues = getFormValues(formName);
              const day = $moment(formValues.shiftDate, "DD/MM/YYYY").format(
                "dddd"
              );
              const params = {
                startDate: $moment(formValues.shiftDate, "DD/MM/YYYY").format(
                  "YYYY-MM-DD"
                ),
                endDate: $moment(formValues.shiftDate, "DD/MM/YYYY").format(
                  "YYYY-MM-DD"
                ),
                schedule: [
                  {
                    start_time: $moment(formValues.shiftTime.timeStart).format(
                      "HH:mm"
                    ),
                    end_time: $moment(formValues.shiftTime.timeEnd).format(
                      "HH:mm"
                    ),
                    date: $moment(formValues.shiftDate, "DD/MM/YYYY").format(
                      "YYYY-MM-DD"
                    ),
                  },
                ],
                is_block_shift: formValues.isBlockShift == true ? 1 : 0,
                paying_for_travel: formValues.paying_for_travel,
                pay_for_accommodation: formValues.pay_for_accommodation,
                enable_travel_allowance_for_first_and_last_day: formValues.enable_travel_allowance_for_first_and_last_day,
                pay_for_flights: formValues.pay_for_flights,
                max_travel_compensation: formValues.max_travel_amount,
                solo: formValues.solo ? 1 : 0,
                admin_aids: formValues.admin_aids ? 1 : 0,
                num_of_tech: formValues.num_of_tech,
                open_up: formValues.open_up ? 1 : 0,
                close: formValues.close ? 1 : 0,
                platform_role_id: formValues.platform_role_id,
                covid_cert_required: formValues.covid_cert_required,
                notes: formValues.notes,
                based_on_shift: shift.value.id,
                visibility_status: formValues.visibility_status,
                more_option_internal_pools: formValues.more_option_internal_pools,
                more_option_prefered_locum: formValues.more_option_prefered_locum,
                more_option_open_marketplace: formValues.more_option_open_marketplace,
                more_option_agency: formValues.more_option_agency,
                shift_application_type: formValues.shift_application_type,
                application_radius: formValues.application_radius || null,
              };

              if (formValues.parking_check) {
                params.parking = formValues.parking;
              }

              if (day === "Saturday" || day == "Sunday") {
                if (day === "Saturday" && day == "Sunday") {
                  if (shiftJob.weekendMaxRate != null && shiftJob.weekendMinRate != null) {
                    params.weekend_min_rate = formValues.rate.minRate;
                    params.weekend_max_rate = formValues.rate.maxRate;
                  }
                } else if (day === "Saturday") {
                  if (shiftJob.saturdayMinRate != null && shiftJob.saturdayMaxRate != null) {
                    params.saturday_min_rate = formValues.rate.minRate;
                    params.saturday_max_rate = formValues.rate.maxRate;
                  } else {
                    params.saturday_min_rate = formValues.rate.minRate;
                    params.saturday_max_rate = formValues.rate.maxRate;
                  }
                } else if (day == "Sunday") {
                  if (shiftJob.sundayMinRate != null && shiftJob.sundayMaxRate != null) {
                    params.sunday_min_rate = formValues.rate.minRate;
                    params.sunday_max_rate = formValues.rate.maxRate;
                  } else {
                    params.sunday_min_rate = formValues.rate.minRate;
                    params.sunday_max_rate = formValues.rate.maxRate;
                  }
                }
              } else {
                params.min_rate = formValues.rate.minRate;
                params.max_rate = formValues.rate.maxRate;
              }

              if (formsDataArray.shiftForm.language_conditions.value == false) {
                delete params.languages;
              } else {
                params.languages = formValues.languages;
              }
              await $store.dispatch("UPDATE_JOB", { jobId: route.params.jobId, params });

              ElMessage({
                type: "success",
                message: "Thank You! Your shift has been successfully edited.",
              });
              closeModal();
              $router.push({
                name: "search",
              });
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const isNextButtonDisabled = computed(() => {
     
      const visibilityStatus = formsData.shiftForm.visibility_status.value;
      if (
        formsData.shiftForm.shift_application_type.value === 2 &&
        (formsData.shiftForm.application_radius.value === null ||
          formsData.shiftForm.application_radius.value === undefined)
      ) {
        return true;
      }
      // If no visibility options are selected, disable next button
      if (visibilityStatus.length === 0) return true;
      // Check for zero values in specific fields
      const hasZeroValues = () => {
        // Check internal pools
        for (const poolId in formsData.shiftForm.more_option_internal_pools) {
          if (formsData.shiftForm.more_option_internal_pools[poolId]?.value?.value === 0) {
            return true;
          }
        }

        // Check other specific fields
        return (
          formsData.shiftForm.more_option_prefered_locum.value?.value === 0 ||
          formsData.shiftForm.more_option_open_marketplace.value?.value === 0 ||
          formsData.shiftForm.more_option_agency.value?.value === 0
        );
      };

      if (hasZeroValues()) {
        return true;
      }
      // Check each selected visibility option
      for (const status of visibilityStatus) {
        const option = visibiltyOptions.find(opt => opt.value === status);
        console.log("🚀 ~ setup ~ option:", option)
        if (!option) continue;



        // Handle Preferred Locum (value: 2)
        if (status === 2) {
          const prefLocum = formsData.shiftForm.more_option_prefered_locum.value;
          if (prefLocum.value === null) return true;
          if (preferedRadioSelection.value === 'choose_specific' && prefLocum.locums.length === 0) {
            return true;
          }
          continue;
        }

        // Handle Agency (value: 4)
        if (status === 4) {
          const agency = formsData.shiftForm.more_option_agency.value;
          if (agency.value === null) return true;
          if (agencyRadioSelection.value === 'choose_specific' && agency.agencies.length === 0) {
            return true;
          }
          continue;
        }

        // Handle Dynamic Internal Pools
        if (option.isDynamicPool) {
          const poolId = option.value; // This is the pool.id
          const radioSelection = poolRadioSelections[poolId];
          console.log("🚀 ~ setup ~ radioSelection:", radioSelection)
          const poolData = formsData.shiftForm.more_option_internal_pools[poolId];

          // Check if radio selection exists
          if (radioSelection === undefined || radioSelection === null) return true;

          // Check if specific professionals are selected when needed
          if (radioSelection === 'choose_specific' &&
            (!poolData?.value?.locums || poolData.value.locums.length === 0)) {
            return true;
          }
          continue;
        }

        // Handle Open Marketplace (value: 3) - only needs value check
        if (status === 3) {
          const marketplace = formsData.shiftForm.more_option_open_marketplace.value;
          if (marketplace.value === null) return true;
          continue;
        }
      }

      // All validations passed
      return false;
    });
    


    const agencyValue = computed({
      get: () => formsData.shiftForm.more_option_agency.value.value,
      set: (newValue) =>
        (formsData.shiftForm.more_option_agency.value.value = newValue),
    });

    const internalPoolValue = computed({
      get: () => formsData.shiftForm.more_option_internal_pool.value.value,
      set: (newValue) =>
        (formsData.shiftForm.more_option_internal_pool.value.value = newValue),
    });

    const preferedValue = computed({
      get: () => formsData.shiftForm.more_option_prefered_locum.value.value,
      set: (newValue) =>
        (formsData.shiftForm.more_option_prefered_locum.value.value = newValue),
    });


    const showAgencyDetails = (agency) => {
      currentDetails.value = agency;
      detailsTitle.value = 'Agency Details';
      const selected = agencies.value.find(a => a.id === agency.id);
      console.log("🚀 ~ handleCheckboxClick ~ selected:", selected);
      if (selected) {
        selectedAgencyData.value = {
          name: selected.name,
          email: selected.email,
          rates: selected.rate,
          notes: selected.notes,
        };
        showDialog.value = true;
      }
    };

    let activeName = ref("Visibility");
    let tabDisabled = ref(false);

    async function handleClick() {
      await new Promise((resolve) => {
        formsRefs["shiftForm"].value.validate((valid) => {
          if (valid && !isNextButtonDisabled.value) {
            resolve(true);
          } else {
            return reject();
          }
          // Resolve the promise when validation is complete
        });
      });
    }

  
    const next = (formName, currentTab, nextTab) => {

      formsRefs[formName].value.validate((valid) => {

        if (valid && !isNextButtonDisabled.value) {
          (async () => {
            try {

              checkFormChanged("shiftForm", true);
              tabDisabled.value = false;
              const nextTabElement = document.getElementById(`tab-${nextTab}`);

              if (nextTabElement) {
                nextTabElement.click();
              } else {
                console.log("Next tab not found.");
              }


            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const onChangeLang = (e) => {
      if (e == false) {
        formsData.shiftForm.languages.selectValue = [null];
        // formsData.shiftForm.languages.value = ;
      } else {
        setOption(formsData.shiftForm.languages.value);
      }
    };

    const onChangeTech = (e) => {
      if (e == false) {
        formsData.shiftForm.num_of_tech.value = null;
      }
    };
    const onChangeNotes = (e) => {
      if (e == false) {
        formsData.shiftForm.notes.value = "";
      }
    };
    const onChangeParking = (e) => {
      if (e == true && formsData.shiftForm.parking.value === null) {
        formsData.shiftForm.parking.value = "";
      }
      if (e == false) {
        formsData.shiftForm.parking.value = "";
      }
    };

    const covidRequiredOption = [
      { label: "Not Required", value: 0 },
      { label: "Mandatory", value: 1 },
      { label: "Nice to have", value: 2 },
    ];

    const travelPaymentOptions = [
      {
        label: "No Travel",
        input: null,
        value: 0,
        description: "No travel compensation paid to locum for this job",
      },
      {
        label: "Partially compensation",
        value: 1,
        input: {
          value: null,
        },
        description: ""
        // description:
        //   "Travel compensation paid to locum for this job for every Km travelled to each shift. Optional to add Max Distance to limit payable distance, if no value then every Km will have travel applied  ",
      },
      {
        label: "Full compensation",
        input: null,
        value: 2,
        description: ""
        // description: `Travel to be paid to locum on the first and last day of consecutive shifts where the distance is above 200km`,
      },
    ];

    const radioSelected = function () {
      formsData.shiftForm.round_trip.value = 0
    }

    const checkLocumAvailability = (visibilityOption) => {
      if (visibilityOption.visibility) {
        return false;
      }

      // Exception for "Open Marketplace" option
      if (visibilityOption.value === 3) {
        return false;
      }
      return true;
    }

    const {
      onFormMaskAccept,
      checkFormValidation,
      copyFormResetValue,
      checkFormChanged,
      // checkFieldsEqual,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    function handlePreferedRadioChange(val) {
      if (val === "notify_all") {
        formsData.shiftForm.more_option_prefered_locum.value.locums = []
      }
    }

    function handleChoosePreferedSpecificClick() {
      preferedDrawer.value = true
    }
    function handleInternalRadioChange(val, poolId) {
      poolRadioSelections[poolId] = val;
      // formsData.shiftForm.more_option_internal_pools[poolId].value.value = val;

      if (val === 'notify_all') {
        formsData.shiftForm.more_option_internal_pools[poolId].value.locums = [];
      }
    }

    function handleChooseInternalSpecificClick(poolId) {
      poolRadioSelections[poolId] = 'choose_specific';
      const poolOption = visibiltyOptions.find(opt => opt.value === poolId);
      if (poolOption?.poolData) {
        currentPool.value = poolId;
        internalDrawerLocums.value = poolOption.poolData.internalPoolLocums.map(l => ({
          ...l.locum,
          poolLocumId: l.id,
          type: l.locumType === "6" ? 'Contractor'
            : l.locumType === "2" ? 'Internal Employee'
              : 'External - Marketplace'
        }));
        internalDrawer.value = true;
      }
    }


    function handleAgencyRadioChange(val) {
      if (val === "notify_all") {
        formsData.shiftForm.more_option_agency.value.agencies = []
      }
    }

    function handleChooseAgencySpecificClick() {
      agencyDrawer.value = true
    }

    const updatePreferedLocums = (locums) => {
      formsData.shiftForm.more_option_prefered_locum.value.locums = locums;
    };

    const updateAgencies = (agencies) => {
      formsData.shiftForm.more_option_agency.value.agencies = agencies;
    };
    const updateInternal = (selectedLocums, poolId) => {
      formsData.shiftForm.more_option_internal_pools[poolId].value.locums = selectedLocums;
    };


    const getTagType = (tagTitle) => {
      if (!tagTitle || typeof tagTitle !== 'string') return 'rgb(150, 150, 150)'; // fallback grey

      let hash = 0;
      for (let i = 0; i < tagTitle.length; i++) {
        hash = tagTitle.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Generate RGB components within a bright-ish range (e.g., 50 to 220)
      const r = 50 + (Math.abs(hash) % 170);      // 50 - 219
      const g = 50 + (Math.abs(hash >> 8) % 170);
      const b = 150 + (Math.abs(hash >> 16) % 100); // make blue a bit stronger

      return `rgb(${r}, ${g}, ${b})`;
    };


    const handleTagSelection = (poolId) => {
      console.log('Selected tags for pool', poolId,
        formsData.shiftForm.more_option_internal_pools[poolId].value.tags);
    }


     onBeforeMount(async () => {
      console.log("🚀 ~ onBeforeMount ~ setup");
            try {

                // 1. Load saved data from store first
                const savedData = $store.getters.getJobCreatePageData || shift.value.visibilities.internalPools;
                console.log("🚀 ~ setup ~ savedData:", savedData)
                const savedPools = savedData?.more_option_internal_pools || {};
                console.log("🚀 ~ setup ~ savedPools:", savedPools)

                const response = await $store.dispatch("GET_INTERNAL_POOL_LISTS");
                console.log("Internal pools response:", response);

                if (response?.length) {
                    // 1. Remove existing dynamic pools
                    for (let i = visibiltyOptions.length - 1; i >= 0; i--) {
                        if (visibiltyOptions[i].isDynamicPool) {
                            visibiltyOptions.splice(i, 1);
                        }
                    }
                    formsData.shiftForm.more_option_internal_pools = {};
                    poolRadioSelections.value = {};

                    // 2. Find insert position after Preferred Locum (value: 2)
                    const preferredIndex = visibiltyOptions.findIndex(opt => opt.value === 2);
                    const insertAt = preferredIndex >= 0 ? preferredIndex + 1 : 1;
                    // Clear existing
                    Object.keys(poolRadioSelections).forEach(key => {
                        delete poolRadioSelections[key];
                    });
                    // 3. Add pools with header only on first item
                    response.forEach((pool, index) => {
                        const isFirstPool = index === 0;
                        const poolId = pool.id;
                         let description = "Your internal employees or contractors";
                        if(pool.structure?.name === 'Brand' || pool.structure?.name === 'Banner' || pool.structure?.name === 'Membership') {
                            // Group structure without subscription
                              if (pool.structure?.name) {
                                description = pool.structure?.name + " pool";
                            }else{
                                description = "Membership pool";
                            }
                        }
                        // Check if we have saved data for this pool
                        const savedPool = savedPools[poolId];
                        const hasSavedData = savedPool && savedPool.value;
                        const poolOption = {
                            label: pool.displayName,
                            value: poolId,
                            description: description,
                            radioOption: "internal_pool",
                            percent: visibilityInternalStaff,
                            visibility: pool.internalPoolLocums?.length > 0,
                            noLocum: "No professionals available in this pool",
                            groupTitle: isFirstPool ? "Internal Pool" : "",
                            groupSubText: isFirstPool ? "Professionals within your network" : "",
                            radioSelection: "notify_all",
                            icon: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="8" fill="#DEFAF9"/><path d="M19.4442 23.9995V22.2217C19.4442 21.2787 19.0696 20.3744 18.4028 19.7076C17.736 19.0408 16.8316 18.6662 15.8886 18.6662H10.5553C9.61232 18.6662 8.70795 19.0408 8.04115 19.7076C7.37436 20.3744 6.99976 21.2787 6.99976 22.2217V23.9995M19.4442 8.11328C20.2067 8.31094 20.8819 8.75618 21.3639 9.37911C21.8459 10.002 22.1075 10.7674 22.1075 11.5551C22.1075 12.3427 21.8459 13.1081 21.3639 13.731C20.8819 14.3539 20.2067 14.7992 19.4442 14.9968M24.7775 23.9995V22.2217C24.7769 21.4339 24.5147 20.6686 24.0321 20.046C23.5494 19.4234 22.8737 18.9787 22.1109 18.7817" stroke="#00B7AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.2221 15.1111C15.1857 15.1111 16.7776 13.5192 16.7776 11.5556C16.7776 9.59188 15.1857 8 13.2221 8C11.2584 8 9.6665 9.59188 9.6665 11.5556C9.6665 13.5192 11.2584 15.1111 13.2221 15.1111Z" stroke="#00B7AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                            poolData: pool,
                            isDynamicPool: true,
                            isFirstPool: isFirstPool, // Flag for template
                            tags: pool.tags || [],
                            locumsCount: pool.internalPoolLocums?.length || 0,
                        };

                        visibiltyOptions.splice(insertAt + index, 0, poolOption);

                        // Initialize form state
                        // Initialize form data for this pool
                        // Initialize form data - use saved data if available
                        formsData.shiftForm.more_option_internal_pools[poolId] = {
                        value: {
                            value: hasSavedData ? savedPool.value.value : null, // Your default value
                            locums: hasSavedData ? [...savedPool.value.locums] : [], // Copy array
                            tags: hasSavedData ? [...(savedPool.value.tags || [])] : []
                        }
                        };

                        // if (hasSavedData && savedPools[poolId].value.locums.length > 0) {
                        //     poolRadioSelections[poolId] = 'choose_specific';
                        // } else {
                        //     poolRadioSelections[poolId] = 'notify_all'; // Default selection
                        // }

                         console.log("🚀 ~ onBeforeMount ~ sdsdsdsetup", visibiltyOptions);

                        if(savedData.more_option_prefered_locum.locums.length > 0) {
                            preferedRadioSelection.value = 'choose_specific';
                        } else {
                            preferedRadioSelection.value = 'notify_all'; // Default selection

                        }

                        if(savedData.more_option_agency.agencies.length > 0) {
                            agencyRadioSelection.value = 'choose_specific';
                        } else {
                            agencyRadioSelection.value = 'notify_all'; // Default selection

                        }
                        // initPoolRadioState(poolId);
                    });

                    // Re-apply shift pool selections after async pool list init.
                    // openModal can run before this finishes and would otherwise be wiped.
                    if (shift.value?.visibilities) {
                      const shiftVisibilities = shift.value.visibilities;
                      const rawVisibilityStatus = shiftVisibilities.visibilityStatus
                        || shiftVisibilities.visibility_status
                        || formsData.shiftForm.visibility_status.value
                        || [];
                      if (Array.isArray(rawVisibilityStatus) && rawVisibilityStatus.length) {
                        formsData.shiftForm.visibility_status.value = rawVisibilityStatus.map((status) => {
                          const poolOption = visibiltyOptions.find(
                            (opt) => opt.isDynamicPool && String(opt.value) === String(status)
                          );
                          return poolOption ? poolOption.value : status;
                        });
                      }
                      applyInternalPoolsFromShift(shiftVisibilities);
                    }
                }
            } catch (error) {
                console.error("Error loading internal pools:", error);
            }
        });

         const checkPreferedRadioIsChooseSpecific = computed(() => {
            return preferedRadioSelection.value === 'choose_specific' && formsData.shiftForm?.more_option_prefered_locum?.value?.locums?.length === 0;
        });

        const checkAgencyRadioIsChooseSpecific = computed(() => {
            return agencyRadioSelection.value === 'choose_specific' && formsData.shiftForm?.more_option_agency?.value?.agencies?.length === 0;
        });

        const getPoolError = (option) => {
            if (!option.isDynamicPool) return false;

            const poolId = option.value;
            const radioSelection = poolRadioSelections[poolId];
            const poolData = formsData.shiftForm.more_option_internal_pools[poolId];

            // Check if radio selection exists
            if (radioSelection === undefined || radioSelection === null) return false;

            // Check if specific professionals are selected when needed
            return radioSelection === 'choose_specific' &&
                (!poolData?.value?.locums || poolData.value.locums.length === 0);
        };


    return {
      formsData,
      openModal,
      closeModal,
      // loading,
      modalVisible,
      shift,
      bottomDropUp,
      onFormMaskAccept,
      checkFormValidation,
      calendarAttrs,
      calendarRef,
      calendarUpdate,
      dateSelected,
      disabledDates,
      submit,
      next,
      activeName,
      tabDisabled,
      onChangeLang,
      onChangeNotes,
      onChangeParking,
      platformRoleOption,
      covidRequiredOption,
      onChangeTech,
      customLabel,
      selectOptions,
      removeOption,
      radioSelected,
      travelPaymentOptions,
      showInputField,
      handleSelectChange,
      samePayRate,
      visibiltyOptions,
      selectedInternalPoolOption,
      guestLocums,
      agencies,
      updateVisibilityOptions,
      userRootData,
      user,
      agenciesAvailable,
      internalStaffAvailable,
      preferedLocumAvailable,
      calculateHourValue,
      handleCheckboxClick,
      selectedAgency,
      showDialog,
      selectedAgencyData,
      prevVisibilityStatus,
      preferedLocums,
      isNextButtonDisabled,
      enableTabClick,
      handleClick,
      visibiltyAccessOptions,
      radiusAccessValue,
      updateVisibilityAccess,
      handleCheckboxClickForOnboarding,
      subscription,
      shouldDisableCheckbox,
      // handleCheckboxClickGuestLocum,
      onboardingFeature,
      getInternalEmployeeGroups,
      internalEmployeeGroups,
      isAustralia,
      subscriptionAvailiabilityText,
      checkSubscriptionEnabledDIsabled,
      checkLocumAvailability,
      message,
      pharmacyIsInGroupAndGroupHaveSubscriptionAvailabilityText,
      pharmacyIsInGroupAndGroupHaveSubscription,
      preferedRadioSelection,
      handlePreferedRadioChange,
      handleChoosePreferedSpecificClick,
      agencyRadioSelection,
      agencyDrawer,
      handleAgencyRadioChange,
      handleChooseAgencySpecificClick,
      updatePreferedLocums,
      updateAgencies,
      showAgencyDetails,
      handleChooseInternalSpecificClick,
      handleInternalRadioChange,
      updateInternal,
      internalRadioSelection,
      internalDrawer,
      currentPool,
      internalDrawerLocums,
      currentPoolOption,
      poolRadioSelections,
      initPoolRadioState,
      getTagType,
      handleTagSelection,
      agencyValue,
      internalPoolValue,
      preferedValue,
      cancelClick,
      preferedDrawer,
      checkPreferedRadioIsChooseSpecific,
      checkAgencyRadioIsChooseSpecific,
      getPoolError,
      appName,
      pluralizeWord,
      isButtonEnabled
    };
  },
};
</script>

<style lang="scss" scoped>
p {
  &.shift-access-label {
    line-height: 1.2rem;
    font-weight: bold;
    padding: 0;
  }
}

span {
  &.el-radio__label {
    line-height: 1.4rem;
  }
}
</style>